"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f112 = void 0;
exports.f112 = {
    "pg": [
        10,
        11,
        15,
        16,
        17,
        18,
        26,
        27,
        38,
        51,
        52,
        53,
        56,
        58,
        99,
        111,
        129,
        130,
        131,
        137,
        141,
        142,
        145,
        153,
        154,
        156,
        162,
        163,
        165,
        196,
        198,
        199,
        206,
        218,
        239,
        240,
        247,
        250,
        264,
        279,
        297,
        298,
        300,
        304,
        322,
        324,
        341,
        343,
        345,
        347,
        348,
        349,
        350,
        353,
        354,
        355,
        358,
        359,
        371,
        372,
        373,
        383,
        386,
        387,
        394,
        473,
        482,
        485,
        490,
        516,
        518,
        521,
        523,
        525,
        530,
        533,
        542,
        547,
        552,
        554,
        562,
        563,
        573,
        586,
        634,
        637,
        639,
        647,
        651,
        655,
        665,
        667,
        671,
        673,
        680,
        688,
        690,
        720,
        726,
        729,
        739,
        749,
        812,
        813,
        819,
        840,
        842,
        848,
        850,
        851,
        852,
        861,
        865,
        869,
        870,
        875,
        876,
        885,
        927,
        946,
        951,
        954,
        957,
        959,
        964,
        967,
        968,
        987,
        993,
        1009,
        1013,
        1015,
        1016,
        1021,
        1029,
        1032,
        1036,
        1044,
        1046,
        1061,
        1068,
        1096,
        1112,
        1113,
        1157,
        1182,
        1185,
        1187,
        1189,
        1191,
        1209,
        1224,
        1227,
        1232,
        1234,
        1253,
        1255,
        1270,
        1275,
        1289,
        1294,
        1295,
        1302,
        1304,
        1341,
        1433,
        1488,
        1493,
        1506,
        1723,
        1724,
        1728,
        1767,
        1775,
        1794,
        1811,
        1817,
        1818,
        1831,
        1832,
        1845,
        1884,
        1898,
        1915,
        1924,
        1930,
        1931,
        1934,
        1940,
        1941,
        1997,
        2003,
        2004,
        2021,
        2028,
        2074,
        2075,
        2094,
        2097,
        2100,
        2106,
        2192,
        2227,
        2237,
        2249,
        2309,
        2331,
        2333,
        2335,
        2337,
        2338,
        2377,
        2392,
        2411,
        2414,
        2417,
        2472,
        2499,
        2513,
        2517,
        2518,
        2519,
        2522,
        2526,
        2527,
        2529,
        2531,
        2533,
        2543,
        2544,
        2565,
        2570,
        2578,
        2589,
        2592,
        2598,
        2615,
        2623,
        2624,
        2626,
        2636,
        2647,
        2649,
        2667,
        2668,
        2691,
        2697,
        2715,
        2719,
        2720,
        2725,
        2732,
        2755,
        2768,
        2774,
        2783,
        2784,
        2786,
        2791,
        2793,
        2829,
        2830,
        2839,
        2858,
        2889,
        2897,
        2899,
        2929,
        2930,
        2932,
        2943,
        2961,
        2964,
        2992,
        3015,
        3016,
        3018,
        3035,
        3046,
        3055,
        3076,
        3079,
        3082,
        3112,
        3114,
        3139,
        3157,
        3159,
        3161,
        3206,
        3208,
        3209,
        3222,
        3229,
        3231,
        3232,
        3246,
        3273,
        3291,
        3293,
        3309,
        3328,
        3353,
        3370,
        3382,
        3389,
        3398,
        3487,
        3489,
        3494,
        3498,
        3501,
        3502,
        3507,
        3517,
        3520,
        3525,
        3536,
        3565,
        3581,
        3624,
        3638,
        3654,
        3662,
        3669,
        3678,
        3680,
        3686,
        3687,
        3690,
        3699,
        3721,
        3725,
        3726,
        3737,
        3771,
        3776,
        3779,
        3780,
        3784,
        3788,
        3798,
        3799,
        3800,
        3806,
        3807,
        3810,
        3812,
        3815,
        3837,
        3842,
        3851,
        3862,
        3864,
        3872,
        3879,
        3890,
        3894,
        3895,
        3898,
        3899,
        3900,
        3903,
        3906,
        3907,
        3909,
        3920,
        3957,
        3958,
        3962,
        3963,
        3965,
        3971,
        3992,
        3994,
        3996,
        4017,
        4018,
        4030,
        4031,
        4047,
        4051,
        4082,
        4087,
        4098,
        4119,
        4121,
        4125,
        4128,
        4134,
        4138,
        4159,
        4160,
        4166,
        4216,
        4219,
        4232,
        4236,
        4237,
        4248,
        4273,
        4275,
        4282,
        4283,
        4285,
        4286,
        4310,
        4325,
        4327,
        4332,
        4365,
        4378,
        4379,
        4385,
        4399,
        4429,
        4432,
        4448,
        4458,
        4501,
        4522,
        4560,
        4606,
        4609,
        4615,
        4621,
        4622,
        4627,
        4633,
        4641,
        4642,
        4646,
        4649,
        4650,
        4652,
        4653,
        4670,
        4681,
        4683,
        4684,
        4689,
        4700,
        4701,
        4729,
        4732,
        4751,
        4760,
        4761,
        4772,
        4777,
        4814,
        4825,
        4826,
        4829,
        4830,
        4849,
        4861,
        4863,
        4878,
        4881,
        4889,
        4909,
        4915,
        4916,
        4917,
        4919,
        4923,
        4933,
        4948,
        4980,
        4995,
        4997,
        4998,
        4999,
        5002,
        5003,
        5005,
        5007,
        5013,
        5030,
        5031,
        5035,
        5092,
        5095,
        5096,
        5097,
        5103,
        5106,
        5109,
        5122,
        5125,
        5137,
        5146,
        5150,
        5160,
        5162,
        5165,
        5175,
        5176,
        5177,
        5180,
        5181,
        5215,
        5217,
        5227,
        5251,
        5261,
        5276,
        5281,
        5285,
        5287,
        5290,
        5291,
        5302,
        5305,
        5319,
        5332,
        5333,
        5336,
        5338,
        5339,
        5346,
        5347,
        5348,
        5398,
        5406,
        5412,
        5457,
        5469,
        5472,
        5475,
        5484,
        5489,
        5492,
        5517,
        5523,
        5586,
        5587,
        5596,
        5602,
        5604,
        5619,
        5623,
        5625,
        5632,
        5636,
        5646,
        5656,
        5680,
        5694,
        5700,
        5727,
        5741,
        5742,
        5749,
        5754,
        5768,
        5784,
        5858,
        5880,
        5888,
        5912,
        5917,
        5923,
        5925,
        5926,
        5927,
        5931,
        5932,
        5933,
        5944,
        5945,
        5956,
        5978,
        6000,
        6003,
        6005,
        6010,
        6059,
        6081,
        6091,
        6098,
        6102,
        6105,
        6114,
        6120,
        6154,
        6163,
        6170,
        6182,
        6217,
        6235,
        6239,
        6268,
        6273,
        6274,
        6276,
        6278,
        6293,
        6302,
        6320,
        6322,
        6346,
        6366,
        6372,
        6374,
        6376,
        6462,
        6465,
        6469,
        6492,
        6516,
        6549,
        6557,
        6584,
        6591,
        6597,
        6599,
        6637,
        6641,
        6642,
        6693,
        6695,
        6698,
        6699,
        6707,
        6755,
        6783,
        6788,
        6796,
        6828,
        6875,
        6878,
        6880,
        6883,
        6884,
        6885,
        6886,
        6905,
        6914,
        6922,
        6931,
        6949,
        6958,
        6964,
        6965,
        6967,
        6968,
        6978,
        6988,
        6992,
        7006,
        7007,
        7009,
        7014,
        7015,
        7016,
        7037,
        7040,
        7045,
        7051,
        7052,
        7055,
        7056,
        7057,
        7063,
        7100,
        7106,
        7125,
        7131,
        7135,
        7138,
        7143,
        7149,
        7150,
        7152,
        7155,
        7162,
        7168,
        7170,
        7187,
        7190,
        7191,
        7192,
        7195,
        7216,
        7240,
        7243,
        7322,
        7330,
        7331,
        7333,
        7334,
        7337,
        7343,
        7346,
        7349,
        7352,
        7363,
        7417,
        7448,
        7453,
        7456,
        7462,
        7498,
        7507,
        7509,
        7552,
        7564,
        7583,
        7590,
        7604,
        7611,
        7620,
        7630,
        7642,
        7660,
        7666,
        7682,
        7685,
        7687,
        7688,
        7701,
        7707,
        7750,
        7758,
        7759,
        7776,
        7777,
        7781,
        7783,
        7784,
        7785,
        7790,
        7831,
        7836,
        7861,
        7892,
        7895,
        7899,
        7900,
        7901,
        7902,
        7915,
        7928,
        7933,
        7953,
        7968,
        7972,
        7980,
        7985,
        7997,
        7999,
        8002,
        8004,
        8007,
        8009,
        8010,
        8011,
        8014,
        8021,
        8027,
        8034,
        8035,
        8053,
        8054,
        8055,
        8089,
        8110,
        8149,
        8154,
        8157,
        8168,
        8172,
        8174,
        8197,
        8204,
        8207,
        8211,
        8218,
        8220,
        8225,
        8234,
        8241,
        8242,
        8254,
        8273,
        8281,
        8286,
        8287,
        8288,
        8298,
        8299,
        8306,
        8312,
        8319,
        8335,
        8337,
        8348,
        8349,
        8353,
        8356,
        8368,
        8372,
        8405,
        8418,
        8457,
        8459,
        8513,
        8517,
        8578,
        8585,
        8587,
        8626,
        8633,
        8637,
        8755,
        8757,
        8758,
        8759,
        8765,
        8767,
        8771,
        8779,
        8783,
        8784,
        8786,
        8789,
        8808,
        8818,
        8820,
        8823,
        8827,
        8828,
        8829,
        8830,
        8832,
        8837,
        8839,
        8848,
        8851,
        8852,
        8863,
        8873,
        8879,
        8892,
        8893,
        8901,
        8912,
        8917,
        8930,
        8938,
        8939,
        8945,
        8962,
        9008,
        9017,
        9051,
        9053,
        9088,
        9155,
        9159,
        9175
    ],
    "papua new guinea": [
        10,
        11,
        15,
        16,
        17,
        18,
        26,
        27,
        38,
        51,
        52,
        53,
        56,
        58,
        99,
        111,
        129,
        130,
        131,
        137,
        141,
        142,
        145,
        153,
        154,
        156,
        162,
        163,
        165,
        196,
        198,
        199,
        206,
        218,
        239,
        240,
        247,
        250,
        264,
        279,
        297,
        298,
        300,
        304,
        322,
        324,
        341,
        343,
        345,
        347,
        348,
        349,
        350,
        353,
        354,
        355,
        358,
        359,
        371,
        372,
        373,
        383,
        386,
        387,
        394,
        473,
        482,
        485,
        490,
        516,
        518,
        521,
        523,
        525,
        530,
        533,
        542,
        547,
        552,
        554,
        562,
        563,
        573,
        586,
        634,
        637,
        639,
        647,
        651,
        655,
        665,
        667,
        671,
        673,
        680,
        688,
        690,
        720,
        726,
        729,
        739,
        749,
        812,
        813,
        819,
        840,
        842,
        848,
        850,
        851,
        852,
        861,
        865,
        869,
        870,
        875,
        876,
        885,
        927,
        946,
        951,
        954,
        957,
        959,
        964,
        967,
        968,
        987,
        993,
        1009,
        1013,
        1015,
        1016,
        1021,
        1029,
        1032,
        1036,
        1044,
        1046,
        1061,
        1068,
        1096,
        1112,
        1113,
        1157,
        1182,
        1185,
        1187,
        1189,
        1191,
        1209,
        1224,
        1227,
        1232,
        1234,
        1253,
        1255,
        1270,
        1275,
        1289,
        1294,
        1295,
        1302,
        1304,
        1341,
        1433,
        1488,
        1493,
        1506,
        1723,
        1724,
        1728,
        1767,
        1775,
        1794,
        1811,
        1817,
        1818,
        1831,
        1832,
        1845,
        1884,
        1898,
        1915,
        1924,
        1930,
        1931,
        1934,
        1940,
        1941,
        1997,
        2003,
        2004,
        2021,
        2028,
        2074,
        2075,
        2094,
        2097,
        2100,
        2106,
        2192,
        2227,
        2237,
        2249,
        2309,
        2331,
        2333,
        2335,
        2337,
        2338,
        2377,
        2392,
        2411,
        2414,
        2417,
        2472,
        2499,
        2513,
        2517,
        2518,
        2519,
        2522,
        2526,
        2527,
        2529,
        2531,
        2533,
        2543,
        2544,
        2565,
        2570,
        2578,
        2589,
        2592,
        2598,
        2615,
        2623,
        2624,
        2626,
        2636,
        2647,
        2649,
        2667,
        2668,
        2691,
        2697,
        2715,
        2719,
        2720,
        2725,
        2732,
        2755,
        2768,
        2774,
        2783,
        2784,
        2786,
        2791,
        2793,
        2829,
        2830,
        2839,
        2858,
        2889,
        2897,
        2899,
        2929,
        2930,
        2932,
        2943,
        2961,
        2964,
        2992,
        3015,
        3016,
        3018,
        3035,
        3046,
        3055,
        3076,
        3079,
        3082,
        3112,
        3114,
        3139,
        3157,
        3159,
        3161,
        3206,
        3208,
        3209,
        3222,
        3229,
        3231,
        3232,
        3246,
        3273,
        3291,
        3293,
        3309,
        3328,
        3353,
        3370,
        3382,
        3389,
        3398,
        3487,
        3489,
        3494,
        3498,
        3501,
        3502,
        3507,
        3517,
        3520,
        3525,
        3536,
        3565,
        3581,
        3624,
        3638,
        3654,
        3662,
        3669,
        3678,
        3680,
        3686,
        3687,
        3690,
        3699,
        3721,
        3725,
        3726,
        3737,
        3771,
        3776,
        3779,
        3780,
        3784,
        3788,
        3798,
        3799,
        3800,
        3806,
        3807,
        3810,
        3812,
        3815,
        3837,
        3842,
        3851,
        3862,
        3864,
        3872,
        3879,
        3890,
        3894,
        3895,
        3898,
        3899,
        3900,
        3903,
        3906,
        3907,
        3909,
        3920,
        3957,
        3958,
        3962,
        3963,
        3965,
        3971,
        3992,
        3994,
        3996,
        4017,
        4018,
        4030,
        4031,
        4047,
        4051,
        4082,
        4087,
        4098,
        4119,
        4121,
        4125,
        4128,
        4134,
        4138,
        4159,
        4160,
        4166,
        4216,
        4219,
        4232,
        4236,
        4237,
        4248,
        4273,
        4275,
        4282,
        4283,
        4285,
        4286,
        4310,
        4325,
        4327,
        4332,
        4365,
        4378,
        4379,
        4385,
        4399,
        4429,
        4432,
        4448,
        4458,
        4501,
        4522,
        4560,
        4606,
        4609,
        4615,
        4621,
        4622,
        4627,
        4633,
        4641,
        4642,
        4646,
        4649,
        4650,
        4652,
        4653,
        4670,
        4681,
        4683,
        4684,
        4689,
        4700,
        4701,
        4729,
        4732,
        4751,
        4760,
        4761,
        4772,
        4777,
        4814,
        4825,
        4826,
        4829,
        4830,
        4849,
        4861,
        4863,
        4878,
        4881,
        4889,
        4909,
        4915,
        4916,
        4917,
        4919,
        4923,
        4933,
        4948,
        4980,
        4995,
        4997,
        4998,
        4999,
        5002,
        5003,
        5005,
        5007,
        5013,
        5030,
        5031,
        5035,
        5092,
        5095,
        5096,
        5097,
        5103,
        5106,
        5109,
        5122,
        5125,
        5137,
        5146,
        5150,
        5160,
        5162,
        5165,
        5175,
        5176,
        5177,
        5180,
        5181,
        5215,
        5217,
        5227,
        5251,
        5261,
        5276,
        5281,
        5285,
        5287,
        5290,
        5291,
        5302,
        5305,
        5319,
        5332,
        5333,
        5336,
        5338,
        5339,
        5346,
        5347,
        5348,
        5398,
        5406,
        5412,
        5457,
        5469,
        5472,
        5475,
        5484,
        5489,
        5492,
        5517,
        5523,
        5586,
        5587,
        5596,
        5602,
        5604,
        5619,
        5623,
        5625,
        5632,
        5636,
        5646,
        5656,
        5680,
        5694,
        5700,
        5727,
        5741,
        5742,
        5749,
        5754,
        5768,
        5784,
        5858,
        5880,
        5888,
        5912,
        5917,
        5923,
        5925,
        5926,
        5927,
        5931,
        5932,
        5933,
        5944,
        5945,
        5956,
        5978,
        6000,
        6003,
        6005,
        6010,
        6059,
        6081,
        6091,
        6098,
        6102,
        6105,
        6114,
        6120,
        6154,
        6163,
        6170,
        6182,
        6217,
        6235,
        6239,
        6268,
        6273,
        6274,
        6276,
        6278,
        6293,
        6302,
        6320,
        6322,
        6346,
        6366,
        6372,
        6374,
        6376,
        6462,
        6465,
        6469,
        6492,
        6516,
        6549,
        6557,
        6584,
        6591,
        6597,
        6599,
        6637,
        6641,
        6642,
        6693,
        6695,
        6698,
        6699,
        6707,
        6755,
        6783,
        6788,
        6796,
        6828,
        6875,
        6878,
        6880,
        6883,
        6884,
        6885,
        6886,
        6905,
        6914,
        6922,
        6931,
        6949,
        6958,
        6964,
        6965,
        6967,
        6968,
        6978,
        6988,
        6992,
        7006,
        7007,
        7009,
        7014,
        7015,
        7016,
        7037,
        7040,
        7045,
        7051,
        7052,
        7055,
        7056,
        7057,
        7063,
        7100,
        7106,
        7125,
        7131,
        7135,
        7138,
        7143,
        7149,
        7150,
        7152,
        7155,
        7162,
        7168,
        7170,
        7187,
        7190,
        7191,
        7192,
        7195,
        7216,
        7240,
        7243,
        7322,
        7330,
        7331,
        7333,
        7334,
        7337,
        7343,
        7346,
        7349,
        7352,
        7363,
        7417,
        7448,
        7453,
        7456,
        7462,
        7498,
        7507,
        7509,
        7552,
        7564,
        7583,
        7590,
        7604,
        7611,
        7620,
        7630,
        7642,
        7660,
        7666,
        7682,
        7685,
        7687,
        7688,
        7701,
        7707,
        7750,
        7758,
        7759,
        7776,
        7777,
        7781,
        7783,
        7784,
        7785,
        7790,
        7831,
        7836,
        7861,
        7892,
        7895,
        7899,
        7900,
        7901,
        7902,
        7915,
        7928,
        7933,
        7953,
        7968,
        7972,
        7980,
        7985,
        7997,
        7999,
        8002,
        8004,
        8007,
        8009,
        8010,
        8011,
        8014,
        8021,
        8027,
        8034,
        8035,
        8053,
        8054,
        8055,
        8089,
        8110,
        8149,
        8154,
        8157,
        8168,
        8172,
        8174,
        8197,
        8204,
        8207,
        8211,
        8218,
        8220,
        8225,
        8234,
        8241,
        8242,
        8254,
        8273,
        8281,
        8286,
        8287,
        8288,
        8298,
        8299,
        8306,
        8312,
        8319,
        8335,
        8337,
        8348,
        8349,
        8353,
        8356,
        8368,
        8372,
        8405,
        8418,
        8457,
        8459,
        8513,
        8517,
        8578,
        8585,
        8587,
        8626,
        8633,
        8637,
        8755,
        8757,
        8758,
        8759,
        8765,
        8767,
        8771,
        8779,
        8783,
        8784,
        8786,
        8789,
        8808,
        8818,
        8820,
        8823,
        8827,
        8828,
        8829,
        8830,
        8832,
        8837,
        8839,
        8848,
        8851,
        8852,
        8863,
        8873,
        8879,
        8892,
        8893,
        8901,
        8912,
        8917,
        8930,
        8938,
        8939,
        8945,
        8962,
        9008,
        9017,
        9051,
        9053,
        9088,
        9155,
        9159,
        9175
    ],
    "papua": [
        6120,
        297,
        547,
        586,
        739,
        870,
        957,
        1046,
        1941,
        3517,
        3798,
        3862,
        4018,
        4119,
        4286,
        4378,
        4653,
        4670,
        4830,
        5106,
        5109,
        5587,
        6059,
        6091,
        6222,
        6693,
        6878,
        7052,
        8004,
        8281,
        10,
        11,
        15,
        16,
        17,
        18,
        26,
        27,
        38,
        51,
        52,
        53,
        56,
        58,
        99,
        111,
        129,
        130,
        131,
        137,
        141,
        142,
        145,
        153,
        154,
        156,
        162,
        163,
        165,
        196,
        198,
        199,
        206,
        218,
        239,
        240,
        247,
        250,
        264,
        279,
        298,
        300,
        304,
        322,
        324,
        341,
        343,
        345,
        347,
        348,
        349,
        350,
        353,
        354,
        355,
        358,
        359,
        371,
        372,
        373,
        383,
        386,
        387,
        394,
        473,
        482,
        485,
        490,
        516,
        518,
        521,
        523,
        525,
        530,
        533,
        542,
        552,
        554,
        562,
        563,
        573,
        634,
        637,
        639,
        647,
        651,
        655,
        665,
        667,
        671,
        673,
        680,
        688,
        690,
        720,
        726,
        729,
        749,
        812,
        813,
        819,
        840,
        842,
        848,
        850,
        851,
        852,
        861,
        865,
        869,
        875,
        876,
        885,
        927,
        946,
        951,
        954,
        959,
        964,
        967,
        968,
        987,
        993,
        1009,
        1013,
        1015,
        1016,
        1021,
        1029,
        1032,
        1036,
        1044,
        1061,
        1068,
        1096,
        1112,
        1113,
        1157,
        1182,
        1185,
        1187,
        1189,
        1191,
        1209,
        1224,
        1227,
        1232,
        1234,
        1253,
        1255,
        1270,
        1275,
        1289,
        1294,
        1295,
        1302,
        1304,
        1341,
        1433,
        1488,
        1493,
        1506,
        1723,
        1724,
        1728,
        1767,
        1775,
        1794,
        1811,
        1817,
        1818,
        1831,
        1832,
        1845,
        1884,
        1898,
        1915,
        1924,
        1930,
        1931,
        1934,
        1940,
        1997,
        2003,
        2004,
        2021,
        2028,
        2074,
        2075,
        2094,
        2097,
        2100,
        2106,
        2192,
        2227,
        2237,
        2249,
        2309,
        2331,
        2333,
        2335,
        2337,
        2338,
        2377,
        2392,
        2411,
        2414,
        2417,
        2472,
        2499,
        2513,
        2517,
        2518,
        2519,
        2522,
        2526,
        2527,
        2529,
        2531,
        2533,
        2543,
        2544,
        2565,
        2570,
        2578,
        2589,
        2592,
        2598,
        2615,
        2623,
        2624,
        2626,
        2636,
        2647,
        2649,
        2667,
        2668,
        2691,
        2697,
        2715,
        2719,
        2720,
        2725,
        2732,
        2755,
        2768,
        2774,
        2783,
        2784,
        2786,
        2791,
        2793,
        2829,
        2830,
        2839,
        2858,
        2889,
        2897,
        2899,
        2929,
        2930,
        2932,
        2943,
        2961,
        2964,
        2992,
        3015,
        3016,
        3018,
        3035,
        3046,
        3055,
        3076,
        3079,
        3082,
        3112,
        3114,
        3139,
        3157,
        3159,
        3161,
        3206,
        3208,
        3209,
        3222,
        3229,
        3231,
        3232,
        3246,
        3273,
        3291,
        3293,
        3309,
        3328,
        3353,
        3370,
        3382,
        3389,
        3398,
        3487,
        3489,
        3494,
        3498,
        3501,
        3502,
        3507,
        3520,
        3525,
        3536,
        3565,
        3581,
        3624,
        3638,
        3654,
        3662,
        3669,
        3678,
        3680,
        3686,
        3687,
        3690,
        3699,
        3721,
        3725,
        3726,
        3737,
        3771,
        3776,
        3779,
        3780,
        3784,
        3788,
        3799,
        3800,
        3806,
        3807,
        3810,
        3812,
        3815,
        3837,
        3842,
        3851,
        3864,
        3872,
        3879,
        3890,
        3894,
        3895,
        3898,
        3899,
        3900,
        3903,
        3906,
        3907,
        3909,
        3920,
        3957,
        3958,
        3962,
        3963,
        3965,
        3971,
        3992,
        3994,
        3996,
        4017,
        4030,
        4031,
        4047,
        4051,
        4082,
        4087,
        4098,
        4121,
        4125,
        4128,
        4134,
        4138,
        4159,
        4160,
        4166,
        4216,
        4219,
        4232,
        4236,
        4237,
        4248,
        4273,
        4275,
        4282,
        4283,
        4285,
        4310,
        4325,
        4327,
        4332,
        4365,
        4379,
        4385,
        4399,
        4429,
        4432,
        4448,
        4458,
        4501,
        4522,
        4560,
        4606,
        4609,
        4615,
        4621,
        4622,
        4627,
        4633,
        4641,
        4642,
        4646,
        4649,
        4650,
        4652,
        4681,
        4683,
        4684,
        4689,
        4700,
        4701,
        4729,
        4732,
        4751,
        4760,
        4761,
        4772,
        4777,
        4814,
        4825,
        4826,
        4829,
        4849,
        4861,
        4863,
        4878,
        4881,
        4889,
        4909,
        4915,
        4916,
        4917,
        4919,
        4923,
        4933,
        4948,
        4980,
        4995,
        4997,
        4998,
        4999,
        5002,
        5003,
        5005,
        5007,
        5013,
        5030,
        5031,
        5035,
        5092,
        5095,
        5096,
        5097,
        5103,
        5122,
        5125,
        5137,
        5146,
        5150,
        5160,
        5162,
        5165,
        5175,
        5176,
        5177,
        5180,
        5181,
        5215,
        5217,
        5227,
        5251,
        5261,
        5276,
        5281,
        5285,
        5287,
        5290,
        5291,
        5302,
        5305,
        5319,
        5332,
        5333,
        5336,
        5338,
        5339,
        5346,
        5347,
        5348,
        5398,
        5406,
        5412,
        5457,
        5469,
        5472,
        5475,
        5484,
        5489,
        5492,
        5517,
        5523,
        5586,
        5596,
        5602,
        5604,
        5619,
        5623,
        5625,
        5632,
        5636,
        5646,
        5656,
        5680,
        5694,
        5700,
        5727,
        5741,
        5742,
        5749,
        5754,
        5768,
        5784,
        5858,
        5880,
        5888,
        5912,
        5917,
        5923,
        5925,
        5926,
        5927,
        5931,
        5932,
        5933,
        5944,
        5945,
        5956,
        5978,
        6000,
        6003,
        6005,
        6010,
        6081,
        6098,
        6102,
        6105,
        6114,
        6154,
        6163,
        6170,
        6182,
        6217,
        6235,
        6239,
        6268,
        6273,
        6274,
        6276,
        6278,
        6293,
        6302,
        6320,
        6322,
        6346,
        6366,
        6372,
        6374,
        6376,
        6462,
        6465,
        6469,
        6492,
        6516,
        6549,
        6557,
        6584,
        6591,
        6597,
        6599,
        6637,
        6641,
        6642,
        6695,
        6698,
        6699,
        6707,
        6755,
        6783,
        6788,
        6796,
        6828,
        6875,
        6880,
        6883,
        6884,
        6885,
        6886,
        6905,
        6914,
        6922,
        6931,
        6949,
        6958,
        6964,
        6965,
        6967,
        6968,
        6978,
        6988,
        6992,
        7006,
        7007,
        7009,
        7014,
        7015,
        7016,
        7037,
        7040,
        7045,
        7051,
        7055,
        7056,
        7057,
        7063,
        7100,
        7106,
        7125,
        7131,
        7135,
        7138,
        7143,
        7149,
        7150,
        7152,
        7155,
        7162,
        7168,
        7170,
        7187,
        7190,
        7191,
        7192,
        7195,
        7216,
        7240,
        7243,
        7322,
        7330,
        7331,
        7333,
        7334,
        7337,
        7343,
        7346,
        7349,
        7352,
        7363,
        7417,
        7448,
        7453,
        7456,
        7462,
        7498,
        7507,
        7509,
        7552,
        7564,
        7583,
        7590,
        7604,
        7611,
        7620,
        7630,
        7642,
        7660,
        7666,
        7682,
        7685,
        7687,
        7688,
        7701,
        7707,
        7750,
        7758,
        7759,
        7776,
        7777,
        7781,
        7783,
        7784,
        7785,
        7790,
        7831,
        7836,
        7861,
        7892,
        7895,
        7899,
        7900,
        7901,
        7902,
        7915,
        7928,
        7933,
        7953,
        7968,
        7972,
        7980,
        7985,
        7997,
        7999,
        8002,
        8007,
        8009,
        8010,
        8011,
        8014,
        8021,
        8027,
        8034,
        8035,
        8053,
        8054,
        8055,
        8089,
        8110,
        8149,
        8154,
        8157,
        8168,
        8172,
        8174,
        8197,
        8204,
        8207,
        8211,
        8218,
        8220,
        8225,
        8234,
        8241,
        8242,
        8254,
        8273,
        8286,
        8287,
        8288,
        8298,
        8299,
        8306,
        8312,
        8319,
        8335,
        8337,
        8348,
        8349,
        8353,
        8356,
        8368,
        8372,
        8405,
        8418,
        8457,
        8459,
        8513,
        8517,
        8578,
        8585,
        8587,
        8626,
        8633,
        8637,
        8755,
        8757,
        8758,
        8759,
        8765,
        8767,
        8771,
        8779,
        8783,
        8784,
        8786,
        8789,
        8808,
        8818,
        8820,
        8823,
        8827,
        8828,
        8829,
        8830,
        8832,
        8837,
        8839,
        8848,
        8851,
        8852,
        8863,
        8873,
        8879,
        8892,
        8893,
        8901,
        8912,
        8917,
        8930,
        8938,
        8939,
        8945,
        8962,
        9008,
        9017,
        9051,
        9053,
        9088,
        9155,
        9159,
        9175
    ],
    "pɨne": [
        18
    ],
    "pɨ’ne’": [
        18
    ],
    "pará": [
        22,
        2836,
        4679
    ],
    "pará arára": [
        22
    ],
    "pililo": [
        27
    ],
    "ph": [
        34,
        35,
        46,
        57,
        161,
        164,
        169,
        171,
        174,
        175,
        243,
        265,
        374,
        400,
        489,
        494,
        495,
        496,
        499,
        503,
        509,
        587,
        588,
        590,
        607,
        772,
        786,
        796,
        843,
        844,
        883,
        888,
        902,
        904,
        905,
        924,
        937,
        938,
        975,
        981,
        986,
        1041,
        1042,
        1155,
        1156,
        1165,
        1219,
        1271,
        1358,
        1359,
        1369,
        1409,
        1410,
        1434,
        1526,
        1591,
        1670,
        1712,
        1744,
        1815,
        1998,
        2005,
        2008,
        2017,
        2034,
        2053,
        2193,
        2279,
        2300,
        2301,
        2349,
        2387,
        2388,
        2511,
        2581,
        2948,
        2949,
        3010,
        3011,
        3119,
        3121,
        3145,
        3146,
        3150,
        3152,
        3153,
        3196,
        3198,
        3199,
        3200,
        3201,
        3221,
        3244,
        3248,
        3265,
        3268,
        3275,
        3276,
        3279,
        3288,
        3289,
        3290,
        3469,
        3742,
        3770,
        3775,
        3796,
        3803,
        3804,
        3822,
        3824,
        3902,
        3935,
        3956,
        3967,
        3998,
        4133,
        4141,
        4142,
        4145,
        4186,
        4227,
        4442,
        4600,
        4601,
        4603,
        4607,
        4617,
        4618,
        4659,
        4869,
        4898,
        4914,
        5019,
        5063,
        5065,
        5074,
        5083,
        5085,
        5101,
        5123,
        5827,
        5830,
        6023,
        6024,
        6030,
        6031,
        6184,
        6199,
        6200,
        6287,
        6289,
        6319,
        6378,
        6487,
        6488,
        6587,
        6702,
        6800,
        6807,
        6809,
        6896,
        6923,
        6950,
        6971,
        6972,
        7002,
        7107,
        7121,
        7129,
        7132,
        7133,
        7159,
        7189,
        7267,
        7338,
        7339,
        7340,
        7350,
        7351,
        7406,
        7455,
        7461,
        7512,
        7514,
        7518,
        7556,
        7557,
        7558,
        7559,
        7734,
        7735,
        7819,
        7898,
        8066,
        8165,
        8166,
        8564,
        8628,
        8814,
        8815,
        8874,
        9035
    ],
    "philippines": [
        3201,
        8165,
        8166,
        34,
        35,
        46,
        57,
        161,
        164,
        169,
        171,
        174,
        175,
        243,
        265,
        374,
        400,
        489,
        494,
        495,
        496,
        499,
        503,
        509,
        587,
        588,
        590,
        607,
        772,
        786,
        796,
        843,
        844,
        883,
        888,
        902,
        904,
        905,
        924,
        937,
        938,
        975,
        981,
        986,
        1041,
        1042,
        1155,
        1156,
        1165,
        1219,
        1271,
        1358,
        1359,
        1369,
        1409,
        1410,
        1434,
        1526,
        1591,
        1670,
        1712,
        1744,
        1815,
        1998,
        2005,
        2008,
        2017,
        2034,
        2053,
        2193,
        2279,
        2300,
        2301,
        2349,
        2387,
        2388,
        2511,
        2581,
        2948,
        2949,
        3010,
        3011,
        3119,
        3121,
        3145,
        3146,
        3150,
        3152,
        3153,
        3196,
        3198,
        3199,
        3200,
        3221,
        3244,
        3248,
        3265,
        3268,
        3275,
        3276,
        3279,
        3288,
        3289,
        3290,
        3469,
        3742,
        3770,
        3775,
        3796,
        3803,
        3804,
        3822,
        3824,
        3902,
        3935,
        3956,
        3967,
        3998,
        4133,
        4141,
        4142,
        4145,
        4186,
        4227,
        4442,
        4600,
        4601,
        4603,
        4607,
        4617,
        4618,
        4659,
        4869,
        4898,
        4914,
        5019,
        5063,
        5065,
        5074,
        5083,
        5085,
        5101,
        5123,
        5827,
        5830,
        6023,
        6024,
        6030,
        6031,
        6184,
        6199,
        6200,
        6287,
        6289,
        6319,
        6378,
        6487,
        6488,
        6587,
        6702,
        6800,
        6807,
        6809,
        6896,
        6923,
        6950,
        6971,
        6972,
        7002,
        7107,
        7121,
        7129,
        7132,
        7133,
        7159,
        7189,
        7267,
        7338,
        7339,
        7340,
        7350,
        7351,
        7406,
        7455,
        7461,
        7512,
        7514,
        7518,
        7556,
        7557,
        7558,
        7559,
        7734,
        7735,
        7819,
        7898,
        8066,
        8564,
        8628,
        8814,
        8815,
        8874,
        9035
    ],
    "pal": [
        56,
        6176,
        8669
    ],
    "patois": [
        65,
        1507,
        2471,
        2568,
        2571,
        2572,
        3934,
        6064,
        3315,
        4637
    ],
    "patwa": [
        65,
        200,
        2568,
        2571,
        3315
    ],
    "pitt river": [
        80
    ],
    "pitt": [
        80
    ],
    "panang": [
        107
    ],
    "pazend": [
        112,
        113,
        114
    ],
    "pashai, northeast": [
        120
    ],
    "pashai": [
        120,
        2678,
        6313,
        6314
    ],
    "pashayi": [
        120,
        2678,
        6313,
        6314
    ],
    "pk": [
        125,
        618,
        619,
        710,
        766,
        767,
        768,
        790,
        793,
        811,
        1085,
        1086,
        1125,
        1126,
        1164,
        1517,
        1798,
        1903,
        1904,
        2194,
        2621,
        2635,
        2643,
        2659,
        2660,
        2665,
        2843,
        2846,
        3000,
        3012,
        3340,
        3401,
        3412,
        3499,
        3666,
        3782,
        3783,
        4069,
        4115,
        4117,
        4196,
        4197,
        4198,
        4200,
        4480,
        4502,
        4623,
        4853,
        5153,
        5154,
        5173,
        5552,
        5841,
        5960,
        6015,
        6112,
        6126,
        6131,
        6177,
        6190,
        6282,
        6307,
        6323,
        6704,
        6728,
        6741,
        6745,
        6833,
        6927,
        6928,
        6929,
        6930,
        7443,
        7723,
        7987,
        7988,
        7991,
        8015,
        8076,
        8183,
        8290,
        8477,
        8492,
        8766
    ],
    "pakistan": [
        6177,
        125,
        618,
        619,
        710,
        766,
        767,
        768,
        790,
        793,
        811,
        1085,
        1086,
        1125,
        1126,
        1164,
        1517,
        1798,
        1903,
        1904,
        2194,
        2621,
        2635,
        2643,
        2659,
        2660,
        2665,
        2843,
        2846,
        3000,
        3012,
        3340,
        3401,
        3412,
        3499,
        3666,
        3782,
        3783,
        4069,
        4115,
        4117,
        4196,
        4197,
        4198,
        4200,
        4480,
        4502,
        4623,
        4853,
        5153,
        5154,
        5173,
        5552,
        5841,
        5960,
        6015,
        6112,
        6126,
        6131,
        6190,
        6282,
        6307,
        6323,
        6704,
        6728,
        6741,
        6745,
        6833,
        6927,
        6928,
        6929,
        6930,
        7443,
        7723,
        7987,
        7988,
        7991,
        8015,
        8076,
        8183,
        8290,
        8477,
        8492,
        8766
    ],
    "porapora": [
        129
    ],
    "pundungum": [
        137
    ],
    "putukwam": [
        138
    ],
    "pe": [
        1057,
        5197,
        5198,
        5199,
        5200,
        5201,
        6026,
        2810,
        150,
        167,
        287,
        288,
        302,
        316,
        445,
        467,
        488,
        541,
        575,
        1002,
        1336,
        1364,
        1365,
        1366,
        1367,
        1372,
        1457,
        1489,
        1546,
        1563,
        1578,
        1582,
        1585,
        1586,
        1592,
        1594,
        1686,
        2278,
        2938,
        3072,
        3077,
        3090,
        3093,
        3223,
        3233,
        3247,
        3344,
        3418,
        3473,
        4504,
        4626,
        4628,
        4630,
        5119,
        5247,
        5630,
        5635,
        5835,
        5906,
        5907,
        5916,
        5952,
        6143,
        6148,
        6236,
        6292,
        6297,
        6367,
        6393,
        6397,
        6400,
        6403,
        6407,
        6409,
        6413,
        6414,
        6415,
        6416,
        6417,
        6418,
        6421,
        6422,
        6423,
        6424,
        6425,
        6426,
        6427,
        6430,
        6431,
        6432,
        6434,
        6436,
        6437,
        6438,
        6440,
        6441,
        6442,
        6446,
        6447,
        6448,
        6500,
        6510,
        6850,
        6998,
        7061,
        7717,
        7992,
        8717,
        8720,
        8842
    ],
    "peru": [
        150,
        167,
        287,
        288,
        302,
        316,
        445,
        467,
        488,
        541,
        575,
        1002,
        1336,
        1364,
        1365,
        1366,
        1367,
        1372,
        1457,
        1489,
        1546,
        1563,
        1578,
        1582,
        1585,
        1586,
        1592,
        1594,
        1686,
        2278,
        2938,
        3072,
        3077,
        3090,
        3093,
        3223,
        3233,
        3247,
        3344,
        3418,
        3473,
        4504,
        4626,
        4628,
        4630,
        5119,
        5247,
        5630,
        5635,
        5835,
        5906,
        5907,
        5916,
        5952,
        6143,
        6148,
        6236,
        6292,
        6297,
        6367,
        6393,
        6397,
        6400,
        6403,
        6407,
        6409,
        6413,
        6414,
        6415,
        6416,
        6417,
        6418,
        6421,
        6422,
        6423,
        6424,
        6425,
        6426,
        6427,
        6430,
        6431,
        6432,
        6434,
        6436,
        6437,
        6438,
        6440,
        6441,
        6442,
        6446,
        6447,
        6448,
        6500,
        6510,
        6850,
        6998,
        7061,
        7717,
        7992,
        8717,
        8720,
        8842
    ],
    "partido": [
        161
    ],
    "prokpo": [
        180
    ],
    "peoples": [
        182,
        266,
        788,
        789,
        934,
        1079,
        1101,
        1102,
        1103,
        1549,
        3005,
        3006,
        3007,
        3014,
        3240,
        3285,
        3347,
        3552,
        3650,
        3702,
        3703,
        3849,
        4019,
        4147,
        4224,
        4229,
        4230,
        4231,
        4439,
        4499,
        4545,
        4879,
        4880,
        5199,
        5349,
        5350,
        5408,
        5438,
        5938,
        6007,
        6018,
        6129,
        6130,
        6134,
        6178,
        6247,
        6363,
        6736,
        6956,
        7065,
        7081,
        7147,
        7389,
        7459,
        7474,
        7632,
        7672,
        7762,
        7769,
        7894,
        8504,
        8763
    ],
    "palestanian-jordanian arabic": [
        224
    ],
    "palestanian-jordanian": [
        224
    ],
    "palestinian arabic": [
        224
    ],
    "palestinian": [
        3416,
        224
    ],
    "palestinian-jordanian": [
        224
    ],
    "patamona": [
        6044,
        236
    ],
    "panay": [
        243
    ],
    "patasiwa alfoeren": [
        272
    ],
    "patasiwa": [
        272
    ],
    "pagcah": [
        292
    ],
    "pangcah": [
        292
    ],
    "pangtsah": [
        292
    ],
    "patués": [
        314
    ],
    "paasi-ahá": [
        329
    ],
    "paasiaja": [
        329
    ],
    "paatsiaja": [
        329
    ],
    "patsiaehé": [
        329
    ],
    "poosioho": [
        329
    ],
    "principe": [
        344,
        1607,
        6286,
        6339
    ],
    "pemon": [
        346
    ],
    "pemong": [
        346
    ],
    "pondo": [
        350
    ],
    "pah": [
        366,
        908
    ],
    "pahanan": [
        374
    ],
    "pahanan agta": [
        374
    ],
    "palanan agta": [
        374
    ],
    "palanan": [
        374,
        6287
    ],
    "plains apache": [
        379
    ],
    "plains": [
        6310,
        1610,
        1611,
        6220,
        379,
        627,
        1083,
        5868,
        5869,
        8391,
        3565
    ],
    "pinagé": [
        382
    ],
    "pinaré": [
        382
    ],
    "palik": [
        383
    ],
    "puchikwar": [
        385
    ],
    "pucikwar": [
        385
    ],
    "popengare": [
        389
    ],
    "pignari": [
        396,
        1897
    ],
    "py": [
        403,
        584,
        1335,
        1411,
        2233,
        2242,
        2281,
        2703,
        2818,
        2827,
        4625,
        5448,
        6341,
        6387,
        7058,
        7592,
        7667
    ],
    "paraguay": [
        2827,
        6387,
        7592,
        403,
        584,
        1335,
        1411,
        2233,
        2242,
        2281,
        2703,
        2818,
        4625,
        5448,
        6341,
        7058,
        7667
    ],
    "ps": [
        424,
        3416,
        6668,
        6669,
        6670,
        6976,
        6977
    ],
    "palestine": [
        424,
        3416,
        6668,
        6669,
        6670,
        6976,
        6977
    ],
    "pehuenche": [
        446
    ],
    "pare": [
        460,
        6109,
        6278
    ],
    "pare-asu": [
        460
    ],
    "pesaa": [
        469
    ],
    "pele-ata": [
        485
    ],
    "peleata": [
        485
    ],
    "pudtol": [
        499
    ],
    "pudtol atta": [
        499
    ],
    "people": [
        502
    ],
    "pamplona": [
        503
    ],
    "pamplona atta": [
        503
    ],
    "phula": [
        6124,
        511,
        8840,
        8845,
        8856,
        8884,
        8886,
        8887,
        8888,
        8890,
        8891,
        598,
        8753,
        8792,
        8805,
        8819,
        8883,
        8885,
        8916,
        8965
    ],
    "pakaanuta": [
        513
    ],
    "paka-anuta": [
        513
    ],
    "pae": [
        526
    ],
    "pf": [
        526,
        2453,
        5021,
        5057,
        5062,
        6219,
        6484,
        7860,
        9034
    ],
    "polynesia": [
        526,
        2453,
        5021,
        5057,
        5062,
        6219,
        6484,
        7860,
        9034
    ],
    "preta": [
        545
    ],
    "pulanja": [
        566
    ],
    "pygmée de mongoumba": [
        568
    ],
    "pygmée": [
        568
    ],
    "pygmée de la lobaye": [
        568
    ],
    "pygmées de la sanghas": [
        568
    ],
    "pygmées": [
        568
    ],
    "pertame": [
        569
    ],
    "poturero": [
        584
    ],
    "pyeta": [
        584
    ],
    "pyeta yovai": [
        584
    ],
    "pyta jovai": [
        584
    ],
    "pyta": [
        584
    ],
    "phuphje": [
        598
    ],
    "pedro": [
        603,
        9125,
        602,
        1584,
        4798,
        5121,
        5124,
        5264,
        8972,
        9127,
        9135
    ],
    "puebla": [
        608,
        4812,
        5343,
        5356,
        5645,
        6051,
        4800
    ],
    "plains jarawa": [
        627
    ],
    "pengo": [
        6094,
        628
    ],
    "pakan": [
        641
    ],
    "pukan": [
        641
    ],
    "pukeng": [
        641
    ],
    "puqeng": [
        641
    ],
    "papia": [
        656,
        4637
    ],
    "papiak": [
        656
    ],
    "papiakum": [
        656
    ],
    "pai": [
        6341,
        6797,
        660,
        661,
        818,
        6026,
        6091,
        6276,
        7004,
        8927,
        1037,
        1564,
        6269
    ],
    "pamenyan": [
        664
    ],
    "pokur": [
        666
    ],
    "poukour": [
        666
    ],
    "pukur": [
        666
    ],
    "punamba": [
        670
    ],
    "punapa": [
        670
    ],
    "punuba": [
        670
    ],
    "parole des bana": [
        682
    ],
    "parole": [
        682
    ],
    "parja": [
        706,
        6074
    ],
    "paraja": [
        6072,
        6073,
        706
    ],
    "parajhi": [
        706,
        6072,
        6073
    ],
    "parjhi": [
        706,
        6072,
        6073
    ],
    "parji": [
        706,
        6072,
        6073
    ],
    "paroja": [
        706
    ],
    "poroja": [
        706,
        6074,
        771
    ],
    "patimuni": [
        707
    ],
    "piame": [
        6154,
        729
    ],
    "pura": [
        734
    ],
    "pauri": [
        743,
        782
    ],
    "pauri bareli": [
        743
    ],
    "panyi": [
        744
    ],
    "panyi bai": [
        744
    ],
    "pasa kidd": [
        753
    ],
    "pasa": [
        753
    ],
    "poonan": [
        769,
        770
    ],
    "punan": [
        6224,
        6234,
        6356,
        6357,
        6359,
        6362,
        769,
        770,
        3036,
        8496
    ],
    "poraja katha": [
        771
    ],
    "poraja": [
        771
    ],
    "pahari, mahasu": [
        774
    ],
    "pahari": [
        774,
        3616,
        3617,
        3712,
        2549,
        2550,
        2553,
        3407,
        3408,
        3409,
        3979,
        4827,
        4828,
        6113,
        6131,
        7123,
        7124,
        8567,
        809,
        810,
        828,
        829,
        1391,
        1392,
        1394,
        1936,
        1937,
        1938,
        3611,
        5385,
        5386
    ],
    "pomak": [
        775,
        776,
        777,
        778
    ],
    "paura": [
        782
    ],
    "pawari": [
        782
    ],
    "pawri": [
        782
    ],
    "panəm": [
        787
    ],
    "pasing": [
        788
    ],
    "phsin": [
        788
    ],
    "phsing": [
        788
    ],
    "pu sing": [
        788
    ],
    "pu": [
        6363,
        788,
        1179,
        1245,
        3702,
        3703,
        3704,
        4208,
        9188,
        1057
    ],
    "paliha": [
        805
    ],
    "pai lo": [
        818
    ],
    "piscimas": [
        822,
        823
    ],
    "pere": [
        6109,
        834,
        8315
    ],
    "peri": [
        834
    ],
    "pili": [
        834
    ],
    "piri": [
        834,
        4264
    ],
    "parti-maya": [
        837
    ],
    "pakarla": [
        860
    ],
    "pangkala": [
        860
    ],
    "pankalla": [
        860
    ],
    "parnkala": [
        860
    ],
    "parnkalla": [
        860
    ],
    "punkalla": [
        860
    ],
    "pygmees baka": [
        887
    ],
    "pygmees": [
        887
    ],
    "pygmees de l’est": [
        887
    ],
    "paki": [
        892
    ],
    "pande": [
        893
    ],
    "pakatan": [
        897
    ],
    "pied noir": [
        911,
        912
    ],
    "pied": [
        911,
        912
    ],
    "pa’o": [
        921
    ],
    "pa oh": [
        921
    ],
    "pa": [
        6083,
        6278,
        7871,
        921,
        6017,
        6018,
        6019,
        9108,
        9109,
        3838,
        3839,
        5929,
        5930,
        6121,
        7913,
        1687,
        2109,
        2277,
        2865,
        4500,
        6659,
        6722,
        7440,
        9033
    ],
    "pa'o": [
        921
    ],
    "pa'o karen": [
        921
    ],
    "pao": [
        7672,
        921,
        8753,
        8819,
        7378
    ],
    "pa-o": [
        921
    ],
    "pa-oh": [
        921
    ],
    "pa-u": [
        921
    ],
    "pa’o karen": [
        921
    ],
    "paluai": [
        927
    ],
    "pam-baluan": [
        927
    ],
    "plang": [
        928,
        930,
        931,
        929
    ],
    "pula": [
        928,
        929,
        930,
        931,
        7406,
        8889
    ],
    "pulang": [
        928,
        929,
        930,
        931
    ],
    "pangpung plang": [
        929
    ],
    "pangpung": [
        929
    ],
    "pajo": [
        932
    ],
    "pala": [
        936,
        1251,
        2615,
        6280,
        2923
    ],
    "pakhe-bote": [
        953
    ],
    "pani-bote": [
        953
    ],
    "puku": [
        984
    ],
    "phoke": [
        997,
        999,
        1000,
        1001,
        1957,
        3089
    ],
    "pohbetian": [
        997,
        1000,
        1001
    ],
    "poke": [
        6252,
        997,
        1000,
        1001
    ],
    "pìkkà": [
        1011
    ],
    "pine": [
        1013
    ],
    "pogaya": [
        1016
    ],
    "pearling": [
        1035
    ],
    "pidgin": [
        2406,
        6077,
        7817,
        8212,
        1035,
        1588,
        1806,
        2416,
        2754,
        3102,
        3165,
        5288,
        5505,
        5936,
        3015,
        3016,
        6111,
        1449,
        1450,
        3041,
        4340,
        6158,
        7319,
        7371,
        7666
    ],
    "point": [
        1043,
        6200
    ],
    "po": [
        1046,
        2416,
        6572,
        7861
    ],
    "palya": [
        1047
    ],
    "pali": [
        6138,
        6139,
        6140,
        6141,
        1047
    ],
    "palodi": [
        1047
    ],
    "palya bareli": [
        1047
    ],
    "puriya": [
        1048
    ],
    "proue": [
        1078,
        1079,
        1080
    ],
    "plains bira": [
        1083
    ],
    "pesii": [
        1119
    ],
    "palanoa": [
        1129
    ],
    "panenoa": [
        1129
    ],
    "panera": [
        1129
    ],
    "paneroa": [
        1129,
        5253
    ],
    "pongo": [
        6228,
        1131
    ],
    "pakpak dairi": [
        1147
    ],
    "pakpak": [
        1147
    ],
    "pueh": [
        1151
    ],
    "pu no": [
        1179
    ],
    "punu": [
        6370,
        1179,
        1235,
        1245,
        6244
    ],
    "puuiŋ": [
        1185
    ],
    "pove": [
        1192
    ],
    "pabir": [
        1240
    ],
    "po-nau": [
        1245
    ],
    "pu nu": [
        1245
    ],
    "pela": [
        1251
    ],
    "polo": [
        1251
    ],
    "pirlatapa": [
        1256
    ],
    "pirladapa": [
        1256
    ],
    "pajungu": [
        1257
    ],
    "payungu": [
        1257
    ],
    "pinneegooroo": [
        1262
    ],
    "poodena": [
        1262
    ],
    "poordoona": [
        1262
    ],
    "purduma": [
        1262
    ],
    "purduna": [
        1262
    ],
    "palawan batak": [
        1271
    ],
    "palawan": [
        1271,
        6200,
        6378
    ],
    "pouye": [
        1275
    ],
    "pukhgyal ngur": [
        1278
    ],
    "pukhgyal": [
        1278
    ],
    "pau": [
        6062,
        6063,
        1281,
        1658,
        1659,
        6533
    ],
    "piyo": [
        1286
    ],
    "poavosa": [
        1303
    ],
    "paulo": [
        9067,
        1315
    ],
    "puquina": [
        6367,
        1343
    ],
    "pû": [
        1344
    ],
    "palaachi": [
        1356
    ],
    "phadei": [
        1360
    ],
    "piyapi": [
        1366
    ],
    "paranapura": [
        1366
    ],
    "praja bhasa": [
        1395,
        1396
    ],
    "praja": [
        1395,
        1396
    ],
    "pakara": [
        1426
    ],
    "proto chiapanec": [
        1473
    ],
    "proto": [
        1473
    ],
    "pajonal": [
        1489
    ],
    "patois de st-louis": [
        1507
    ],
    "phanong": [
        1535,
        1536,
        1537
    ],
    "phnong": [
        1535,
        1536,
        1537
    ],
    "pnong": [
        1535,
        1536,
        1537
    ],
    "pong": [
        6247,
        1542
    ],
    "pung": [
        1542
    ],
    "pawi": [
        1545
    ],
    "pinghua, northern": [
        1550,
        1551
    ],
    "pinghua": [
        1550,
        1551,
        1645,
        1646
    ],
    "pínghuà": [
        1550,
        1551,
        1645,
        1646
    ],
    "ping": [
        1550,
        1551,
        1645,
        1646
    ],
    "pulu": [
        1560
    ],
    "pampadeque": [
        1563
    ],
    "pandequebo": [
        1563
    ],
    "poyenisati": [
        1578
    ],
    "palantla": [
        1584
    ],
    "palantla chinantec": [
        1584
    ],
    "pichis": [
        1592
    ],
    "pichis ashéninca": [
        1592
    ],
    "pichis ashéninka": [
        1592
    ],
    "pu-xian": [
        1593
    ],
    "pu-xian chinese": [
        1593
    ],
    "putian": [
        1593
    ],
    "putten": [
        1593
    ],
    "plaines": [
        1610,
        1611
    ],
    "plains cree": [
        1610,
        1611
    ],
    "porteur": [
        1623,
        1624
    ],
    "proper": [
        1626,
        3004,
        3090,
        3226,
        3937,
        3938,
        4196,
        4197,
        4198,
        4200,
        5584,
        6373
    ],
    "pl": [
        1630,
        6180,
        6181,
        6318,
        6550,
        6947,
        7288,
        8385
    ],
    "poland": [
        1630,
        6180,
        6181,
        6318,
        6550,
        6947,
        7288,
        8385
    ],
    "pinghua, southern": [
        1645,
        1646
    ],
    "phum": [
        1664
    ],
    "pandan": [
        1670
    ],
    "pandan bikol": [
        1670
    ],
    "pamié": [
        1681
    ],
    "pamiwa": [
        1681
    ],
    "piro": [
        6146,
        1686
    ],
    "panama": [
        2109,
        1687,
        2277,
        2865,
        4500,
        6659,
        6722,
        7440,
        9033
    ],
    "pohing": [
        1696
    ],
    "pohing kha": [
        1696
    ],
    "pikiwa": [
        1767
    ],
    "pidgin delaware": [
        1806
    ],
    "palong": [
        1852
    ],
    "padang": [
        6936,
        1859,
        4805,
        4806
    ],
    "pinkagama": [
        1911
    ],
    "pinkagarna": [
        1911
    ],
    "papar": [
        1953
    ],
    "pa’par": [
        1953
    ],
    "pappar": [
        1953
    ],
    "piação dos charales do ninhou": [
        1955
    ],
    "piação": [
        1955
    ],
    "pt": [
        1955,
        5184,
        6321,
        6330,
        6338
    ],
    "portugal": [
        1955,
        5184,
        6321,
        6330,
        6338
    ],
    "phoke dolpa": [
        1957
    ],
    "paakantyi": [
        1960
    ],
    "paakanti": [
        1960
    ],
    "paakintyi": [
        1960
    ],
    "paita": [
        1999
    ],
    "popo": [
        2060,
        2061,
        2562,
        2605
    ],
    "parmigiano": [
        2068
    ],
    "piacentino": [
        2068
    ],
    "palin": [
        2103
    ],
    "pari": [
        2103,
        4369,
        5249
    ],
    "pedea": [
        2109
    ],
    "pedée": [
        6889,
        2109
    ],
    "panama embera": [
        2109
    ],
    "pede": [
        2109
    ],
    "pede epenã": [
        2109
    ],
    "pacific": [
        2111,
        2112
    ],
    "pacific gulf yupik": [
        2111,
        2112
    ],
    "pacific yupik": [
        2111,
        2112
    ],
    "pn": [
        2195
    ],
    "pitcairn": [
        6149,
        2195
    ],
    "pr": [
        2196,
        2280,
        6315,
        7628
    ],
    "puerto rico": [
        2196,
        2280,
        6315,
        7628
    ],
    "puerto": [
        6315,
        2196,
        2280,
        7628
    ],
    "pw": [
        2197,
        6037,
        7044,
        7657
    ],
    "palau": [
        6037,
        2197,
        7044,
        7657
    ],
    "part": [
        2208,
        2445,
        5543,
        8081
    ],
    "pe-bae": [
        2231
    ],
    "powok": [
        2233
    ],
    "pawang": [
        2251
    ],
    "persian": [
        2329,
        2330,
        6101,
        8543,
        6309,
        6299,
        7442,
        7443,
        7445
    ],
    "parsi": [
        6296,
        2329,
        4848,
        6285,
        6299
    ],
    "persian, iranian": [
        2329
    ],
    "pahouin": [
        2342
    ],
    "pamue": [
        2342
    ],
    "pangwe": [
        2342
    ],
    "paloor": [
        2343
    ],
    "palar": [
        2343
    ],
    "palor": [
        2343
    ],
    "polanguinon": [
        2349
    ],
    "pulaar": [
        2352,
        2365,
        2366,
        2367,
        2368,
        2369,
        2370,
        2371,
        2372,
        2373,
        2374,
        2375,
        2376
    ],
    "peuhl": [
        2352,
        2365
    ],
    "peul": [
        2352,
        2365,
        2378,
        2379,
        2479,
        2480,
        2482,
        2486,
        2487,
        2488,
        2493,
        2497,
        2498,
        2489
    ],
    "peulh": [
        2352,
        2365,
        2479,
        2480,
        2482,
        2486,
        2487,
        2488,
        2493
    ],
    "pulaar fulfulde": [
        2352,
        2365
    ],
    "pël": [
        2352,
        2365
    ],
    "pilipino": [
        2387,
        2388
    ],
    "pidgin bantu": [
        2406
    ],
    "piki": [
        2406,
        8045
    ],
    "pseudo-bambole": [
        2412
    ],
    "pichi": [
        2416
    ],
    "pichinglis": [
        2416
    ],
    "pidgin de guinea ecuatorial": [
        2416
    ],
    "pidginglis": [
        2416
    ],
    "pm": [
        2454
    ],
    "pierre": [
        2454
    ],
    "patouès": [
        2471
    ],
    "porak": [
        2472
    ],
    "platt": [
        2474,
        4217,
        5375,
        6086,
        8210
    ],
    "plattdüütsk": [
        2474
    ],
    "palata": [
        2479,
        2480
    ],
    "paldena": [
        2479,
        2480
    ],
    "paldida": [
        2479,
        2480
    ],
    "pelta hay": [
        2479,
        2480
    ],
    "pelta": [
        2479,
        2480
    ],
    "pladina": [
        2479,
        2480
    ],
    "pule": [
        2479,
        2480
    ],
    "pullo": [
        2479,
        2480
    ],
    "pular": [
        2483,
        2484,
        2485
    ],
    "poular": [
        2483,
        2484,
        2485
    ],
    "poor’íŋ belé’ŋ": [
        2500
    ],
    "poor’íŋ": [
        2500
    ],
    "poai": [
        2501
    ],
    "pahari bharmauri": [
        2549,
        2550
    ],
    "panchi brahmauri rajput": [
        2549,
        2550
    ],
    "panchi": [
        2549,
        2550
    ],
    "pahari garhwali": [
        2553
    ],
    "phla": [
        2562,
        8697
    ],
    "pla": [
        2562
    ],
    "panchal lohar": [
        2574
    ],
    "panchal": [
        2574
    ],
    "pottangi": [
        2575,
        2576
    ],
    "pottangi ollar gadaba": [
        2575,
        2576
    ],
    "padun": [
        2577
    ],
    "patun": [
        2577
    ],
    "patpatar": [
        2615
    ],
    "patpari": [
        2615
    ],
    "paiawa": [
        2636
    ],
    "parimu": [
        2665,
        2666
    ],
    "province": [
        2668,
        3018,
        4622,
        8939,
        8962
    ],
    "pormi": [
        2669
    ],
    "pessa": [
        2672,
        3877,
        3878
    ],
    "pessy": [
        2672,
        3877,
        3878
    ],
    "poun": [
        2676
    ],
    "pashai, northwest": [
        2678
    ],
    "paraguaio": [
        2703
    ],
    "paraguayan": [
        6387,
        2703
    ],
    "playero": [
        2724
    ],
    "pepojivi": [
        2724
    ],
    "pidgin english": [
        2754
    ],
    "paraná": [
        2758
    ],
    "perkatêjê": [
        2836
    ],
    "parakatêjê": [
        2836
    ],
    "parkatêjê": [
        2836
    ],
    "pará gavião": [
        2836
    ],
    "pukobjê": [
        2836
    ],
    "potu": [
        2841
    ],
    "phong": [
        2887,
        6247
    ],
    "pamosu": [
        2943
    ],
    "parucutu": [
        2954
    ],
    "parukoto-charuma": [
        2954
    ],
    "panchali": [
        2958,
        2959,
        2960
    ],
    "paristani": [
        2958,
        2959,
        2960
    ],
    "pogali": [
        2958,
        2959,
        2960
    ],
    "pogli": [
        2958,
        2959,
        2960
    ],
    "poguli": [
        2958,
        2959,
        2960
    ],
    "piān miáo": [
        2997,
        2998
    ],
    "piān": [
        2997,
        2998
    ],
    "pidgin motu": [
        3015,
        3016
    ],
    "police motu": [
        3015,
        3016
    ],
    "police": [
        3015,
        3016
    ],
    "punan bungan": [
        3036
    ],
    "phon": [
        3040,
        5644,
        7477
    ],
    "phun": [
        3040
    ],
    "phön": [
        3040
    ],
    "palpamadramadra": [
        3052
    ],
    "poi tsat": [
        3086
    ],
    "poi": [
        3086
    ],
    "palamata": [
        3092
    ],
    "palumata": [
        3092
    ],
    "paʻi": [
        3102
    ],
    "purari": [
        3114
    ],
    "portuguese": [
        6321,
        6328,
        6329,
        6330,
        6331,
        6332,
        6333,
        6334,
        6335,
        6336,
        6337,
        6338,
        6339,
        6340,
        4637,
        8097,
        8098,
        6264,
        3135,
        5274,
        7817
    ],
    "pool": [
        3151
    ],
    "peninsula": [
        3177,
        4972
    ],
    "puca-uma": [
        3233
    ],
    "peak": [
        3273
    ],
    "petén itza’ maya": [
        3280
    ],
    "petén": [
        3280
    ],
    "phan": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "pan yao": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "pan": [
        3283,
        3284,
        3285,
        3286,
        3287,
        7382,
        7383,
        7384,
        8186,
        4329,
        4330
    ],
    "poptiꞌ": [
        3307
    ],
    "popti'": [
        3307
    ],
    "popti’": [
        3307
    ],
    "panamanian creole english": [
        3315
    ],
    "panamanian": [
        4500,
        3315
    ],
    "panamanian patois english": [
        3315
    ],
    "patua": [
        3315,
        3435
    ],
    "patwah": [
        3315
    ],
    "pangan": [
        3360
    ],
    "pa-le-chi": [
        3381
    ],
    "palachi": [
        3381
    ],
    "palakhi": [
        3381
    ],
    "palaychi": [
        3381
    ],
    "paku": [
        6179,
        3383
    ],
    "pagu": [
        6119,
        3383
    ],
    "paku karen": [
        3383
    ],
    "patra-saara": [
        3435
    ],
    "puttooas": [
        3435
    ],
    "pepesa-jwira": [
        3448
    ],
    "phu": [
        6132,
        5641,
        3461,
        6124,
        6129,
        6133,
        6134,
        6135,
        8805,
        9047,
        9048,
        8884,
        8888,
        8891
    ],
    "pedá djapá": [
        3474
    ],
    "pedá": [
        3474
    ],
    "pidá-djapá": [
        3474
    ],
    "pueblo": [
        3562,
        3719
    ],
    "pasuma": [
        3581
    ],
    "porja": [
        3588
    ],
    "palu kurumba": [
        3598,
        3599
    ],
    "palu": [
        3598,
        3599,
        4288
    ],
    "pacchmi": [
        3611
    ],
    "pahari, kullu": [
        3616,
        3617
    ],
    "pahari kullu": [
        3616,
        3617
    ],
    "phari kulu": [
        3616,
        3617
    ],
    "phari": [
        3616,
        3617
    ],
    "paï-tavyterã": [
        3628
    ],
    "pai-i": [
        3645,
        3646
    ],
    "pai-yi": [
        3645,
        3646
    ],
    "pai’i’": [
        3645,
        3646
    ],
    "patu": [
        3666
    ],
    "parbate": [
        3676,
        3709,
        5385,
        5386
    ],
    "para": [
        3691,
        6302,
        6392
    ],
    "pouteng": [
        3702,
        3703,
        3704,
        3710
    ],
    "pu thenh": [
        3702,
        3703,
        3704
    ],
    "pegunungan": [
        3708
    ],
    "putenh": [
        3710
    ],
    "pwo": [
        3713,
        3714,
        3715,
        3716,
        3717,
        3718,
        3722,
        6380,
        6382,
        6360
    ],
    "phlong": [
        3713,
        3714,
        3715,
        3716,
        3717,
        3718,
        6380,
        6382
    ],
    "phlou": [
        3713,
        3714,
        3715,
        3716,
        3717,
        3718
    ],
    "pho": [
        3713,
        3714,
        3715,
        3716,
        3717,
        3718,
        6380,
        8792,
        8884,
        8888,
        9188
    ],
    "pwo eastern karen": [
        3713,
        3714,
        3718
    ],
    "phrae": [
        3722
    ],
    "phrae pwo karen": [
        3722
    ],
    "prae": [
        3722
    ],
    "pwo phrae": [
        3722
    ],
    "pomo": [
        6090,
        6093,
        6097,
        6103,
        6257,
        6259,
        6213,
        3723
    ],
    "pole": [
        3726,
        8242
    ],
    "pera": [
        3752
    ],
    "paperyn": [
        3752
    ],
    "paharia": [
        3802,
        4836,
        4837,
        4848
    ],
    "pahariya": [
        3802,
        4848
    ],
    "panbe": [
        3808
    ],
    "panoan": [
        3840,
        5119
    ],
    "pano": [
        5035,
        7552,
        8597,
        6236,
        3840
    ],
    "panoan katukína": [
        3840
    ],
    "permyak": [
        3858,
        3859,
        3860
    ],
    "permian": [
        3858,
        3859,
        3860
    ],
    "pacu": [
        3875
    ],
    "palioariene": [
        3875
    ],
    "payualiene": [
        3875
    ],
    "payuliene": [
        3875
    ],
    "prang": [
        3881
    ],
    "pailelang": [
        3893
    ],
    "panará": [
        3931
    ],
    "panayano": [
        3935
    ],
    "paoua": [
        3969
    ],
    "paganyaw": [
        3976,
        3977
    ],
    "pchcknya": [
        3976,
        3977
    ],
    "pwakanyaw": [
        3976,
        3977
    ],
    "pwakenyaw": [
        3976,
        3977
    ],
    "pia": [
        3984,
        6164
    ],
    "pitiko": [
        3984,
        6164
    ],
    "plapo": [
        3991
    ],
    "plapo krumen": [
        3991
    ],
    "panaras": [
        3996
    ],
    "po-mo": [
        4003
    ],
    "pakadji": [
        4039
    ],
    "psikye": [
        4054
    ],
    "ptsake": [
        4054
    ],
    "pramano": [
        4056
    ],
    "paya kuna": [
        4058
    ],
    "paya": [
        4058,
        6041
    ],
    "paya-pucuro": [
        4058
    ],
    "paya-pucuro kuna": [
        4058
    ],
    "peu": [
        4065
    ],
    "parkari": [
        4069
    ],
    "parkari koli": [
        4069
    ],
    "pit": [
        4081
    ],
    "pindi": [
        4090,
        6100
    ],
    "pakum": [
        4092
    ],
    "parua": [
        4161
    ],
    "pakawa": [
        4167
    ],
    "pekava": [
        4167
    ],
    "pekawa": [
        4167
    ],
    "pygmy": [
        8365,
        4183
    ],
    "pattani": [
        4192,
        4193,
        4707,
        4708
    ],
    "patni": [
        4192,
        4193
    ],
    "panjabi": [
        4196,
        4197,
        4198,
        4200,
        4199,
        6012,
        6013,
        6014,
        6015,
        6131
    ],
    "panjabi proper": [
        4196,
        4197,
        4198,
        4200
    ],
    "punjabi": [
        4199,
        4200,
        6012,
        6013,
        6014,
        6015,
        4196,
        4197,
        4198,
        6131
    ],
    "punjabi, western": [
        4199,
        4200,
        4196,
        4197,
        4198
    ],
    "punjapi": [
        4196,
        4197,
        4198,
        4200
    ],
    "pen ti": [
        4208
    ],
    "pen": [
        4208,
        6874
    ],
    "phubyau": [
        4208
    ],
    "pu beo": [
        4208
    ],
    "pu péo": [
        4208
    ],
    "péo": [
        4208
    ],
    "pubiao": [
        4208
    ],
    "pupeo": [
        4208
    ],
    "poong": [
        4235
    ],
    "pí": [
        4235
    ],
    "póng": [
        4235
    ],
    "ponda": [
        4246
    ],
    "piru": [
        4250
    ],
    "pire": [
        4264
    ],
    "pitilu": [
        4275
    ],
    "pityilu": [
        4275
    ],
    "pimenc": [
        4277
    ],
    "pii": [
        4282
    ],
    "poronga": [
        4285
    ],
    "pantar, western": [
        4287
    ],
    "pantar": [
        4287
    ],
    "pantar barat": [
        4287
    ],
    "paloesch": [
        4288
    ],
    "phó": [
        4302
    ],
    "pur": [
        4307
    ],
    "pahi": [
        4310
    ],
    "phlao": [
        4313
    ],
    "plat": [
        4323,
        8210
    ],
    "pesisir": [
        4353,
        4354
    ],
    "pooroga": [
        4355
    ],
    "päri": [
        4369
    ],
    "pévé": [
        4397
    ],
    "peve": [
        4397
    ],
    "pentecost": [
        4405,
        6685
    ],
    "putuk": [
        6369,
        4425
    ],
    "pondi": [
        4432
    ],
    "panso": [
        4435
    ],
    "pitta pitta": [
        6159,
        4437
    ],
    "pitta": [
        6159,
        4437
    ],
    "phou lao": [
        4439
    ],
    "phou": [
        4439
    ],
    "phuri": [
        4470
    ],
    "päk": [
        4488
    ],
    "panamanian sign language": [
        4500
    ],
    "panameñas": [
        4500
    ],
    "payómkawichum": [
        4523
    ],
    "puget": [
        4536,
        6946
    ],
    "painara": [
        4547
    ],
    "pin": [
        8286,
        4553,
        7163
    ],
    "pasar": [
        5081,
        4598
    ],
    "peranakan": [
        6089,
        4605
    ],
    "paswam": [
        4627
    ],
    "putla": [
        4629,
        5255
    ],
    "pawana": [
        4632
    ],
    "piojé": [
        4636
    ],
    "papia cristao": [
        4637
    ],
    "papia kristang": [
        4637
    ],
    "portuguese patois": [
        4637
    ],
    "português de malaca": [
        4637
    ],
    "português": [
        6328,
        6329,
        6331,
        6332,
        6333,
        6334,
        6335,
        6336,
        6337,
        6338,
        6339,
        6340,
        4637,
        6330,
        7817
    ],
    "pepeha": [
        4646
    ],
    "poeng": [
        4684
    ],
    "pelat utagha": [
        4694,
        4695
    ],
    "pelat": [
        4694,
        4695
    ],
    "pure motu": [
        4701
    ],
    "pure": [
        4701
    ],
    "pattani malay": [
        4707,
        4708
    ],
    "putai": [
        4721,
        6132
    ],
    "pandang": [
        4725
    ],
    "plateau malagasy": [
        4736,
        4738
    ],
    "plateau": [
        4736,
        4738,
        7645
    ],
    "pongpong": [
        4746
    ],
    "peñoles": [
        4803
    ],
    "peñoles mixtec": [
        4803
    ],
    "pinotepa": [
        4807
    ],
    "pinotepa nacional mixtec": [
        4807
    ],
    "puebla-oaxaca": [
        4812,
        8646
    ],
    "panau": [
        4826
    ],
    "pahari mandiyali": [
        4827,
        4828
    ],
    "pantaram": [
        4832
    ],
    "pandaram basha": [
        4832
    ],
    "pandaram": [
        4832
    ],
    "petch": [
        4839
    ],
    "pasha": [
        4839
    ],
    "puta": [
        4840
    ],
    "pre": [
        4847
    ],
    "pre pisia": [
        4847
    ],
    "pisia": [
        4847
    ],
    "pɛrɛ": [
        4847,
        6109
    ],
    "pɛrɛpisjà": [
        4847
    ],
    "pok": [
        4858
    ],
    "pamale": [
        4865
    ],
    "pelasla": [
        4892
    ],
    "pǝlasla": [
        4892
    ],
    "ponna": [
        4943,
        4944,
        4945
    ],
    "pei": [
        6276,
        4950
    ],
    "peguan": [
        4956
    ],
    "pana misima": [
        5007
    ],
    "pana": [
        6238,
        6249,
        5007,
        6236
    ],
    "pana panaeati": [
        5007
    ],
    "panaeati": [
        5007
    ],
    "panaieti": [
        5007
    ],
    "panayeti": [
        5007
    ],
    "paneate": [
        5007
    ],
    "paneyate": [
        5007
    ],
    "piipaash": [
        5041
    ],
    "pasar malay": [
        5081
    ],
    "poule": [
        5084
    ],
    "pantasmas": [
        5114
    ],
    "park": [
        5119
    ],
    "parquenahua": [
        5119
    ],
    "palembang": [
        5133
    ],
    "palembangnese": [
        5133
    ],
    "peti": [
        5138
    ],
    "paanti naattu peeccu": [
        5145
    ],
    "paanti": [
        5145
    ],
    "peeccu": [
        5145
    ],
    "pile": [
        5150
    ],
    "peripheral": [
        5155,
        5156
    ],
    "peripheral mongolian": [
        5155,
        5156
    ],
    "potafa": [
        5167
    ],
    "pensiangan": [
        5170
    ],
    "pe miao": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "peh miao": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "peh": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "pirahã": [
        5246
    ],
    "pirahán": [
        5246
    ],
    "paiquize": [
        5249
    ],
    "presa": [
        5264
    ],
    "patuá": [
        5274
    ],
    "ponam": [
        5336
    ],
    "plattdeutsch": [
        5375
    ],
    "plattdüütsch": [
        5375
    ],
    "pomeranian": [
        5375
    ],
    "pomerano": [
        5375
    ],
    "pommersch": [
        5375
    ],
    "pani": [
        5378,
        6249
    ],
    "panon": [
        5378
    ],
    "pape": [
        5378
    ],
    "pa’non": [
        5378
    ],
    "pesecham": [
        5381
    ],
    "pesechem": [
        5381
    ],
    "pesegem": [
        5381
    ],
    "pahadi": [
        5385,
        5386
    ],
    "parbatiya": [
        5385,
        5386
    ],
    "pene nengone": [
        5401
    ],
    "pene": [
        5401
    ],
    "puh": [
        5405
    ],
    "perce": [
        5414
    ],
    "puuri": [
        5440
    ],
    "pajapan": [
        5458
    ],
    "pajapan nahuatl": [
        5458
    ],
    "paniduria": [
        5494
    ],
    "paimi": [
        5502
    ],
    "patakai": [
        5600,
        5777
    ],
    "pukunna": [
        5613
    ],
    "payap": [
        5620,
        5621
    ],
    "phayap": [
        5620,
        5621
    ],
    "phyap": [
        5620,
        5621
    ],
    "ponyo-gongwang": [
        5643
    ],
    "ponyo naga": [
        5643
    ],
    "ponyo": [
        5643
    ],
    "ponyo-gongwang naga": [
        5643
    ],
    "phom": [
        5644
    ],
    "phom naga": [
        5644
    ],
    "pochuri": [
        5647
    ],
    "pochuri naga": [
        5647
    ],
    "pochury": [
        5647
    ],
    "puimei": [
        5649
    ],
    "puimei naga": [
        5649
    ],
    "pekurehua": [
        5651
    ],
    "picene": [
        5675,
        7067
    ],
    "pokau": [
        5680
    ],
    "pedi": [
        5695,
        5696
    ],
    "pangmi": [
        5701,
        5702,
        5703
    ],
    "pangwa": [
        6055,
        5701,
        5702,
        5703
    ],
    "pujuni": [
        5709
    ],
    "post": [
        5834
    ],
    "provenzale": [
        5834
    ],
    "provençal": [
        6295,
        5834
    ],
    "plains ojibway": [
        5868,
        5869
    ],
    "plains ojibwe": [
        5868,
        5869
    ],
    "peponk": [
        5876
    ],
    "ponka": [
        5904
    ],
    "ppankka": [
        5904
    ],
    "pariana": [
        5907
    ],
    "papago-pima": [
        5937
    ],
    "pápago": [
        5937
    ],
    "piman": [
        5937,
        6142
    ],
    "payagua": [
        5952
    ],
    "punjabi, eastern": [
        6012,
        6013,
        6014,
        6015
    ],
    "parecís": [
        6016
    ],
    "paressí": [
        6016
    ],
    "paresí": [
        6016
    ],
    "pareás": [
        6016
    ],
    "porçoes": [
        6016
    ],
    "pacoh": [
        6017,
        6018,
        6019
    ],
    "pa co": [
        6017,
        6018,
        6019
    ],
    "paco": [
        6017,
        6018,
        6019
    ],
    "pako": [
        6017,
        6018,
        6019
    ],
    "poko": [
        6017,
        6018,
        6019
    ],
    "pokoh": [
        6017,
        6018,
        6019
    ],
    "pacoh (cado dialect)": [
        6018,
        6019
    ],
    "paumarí": [
        6020
    ],
    "pamoari": [
        6020
    ],
    "palmari": [
        6020
    ],
    "purupurú": [
        6020
    ],
    "pagibete": [
        6021
    ],
    "pagabete": [
        6021
    ],
    "paranawát": [
        6022
    ],
    "paranauat": [
        6022
    ],
    "pawate": [
        6022
    ],
    "pawaté": [
        6022
    ],
    "pawaté-wirafed": [
        6022,
        8240
    ],
    "pangasinan": [
        6023,
        6024
    ],
    "pye": [
        6026,
        6384
    ],
    "piyeh": [
        6026
    ],
    "parakanã": [
        6027
    ],
    "parakanân": [
        6027
    ],
    "parocana": [
        6027
    ],
    "pahlavi": [
        6028,
        6029
    ],
    "pampanga": [
        6030,
        6031
    ],
    "pampangan": [
        6030,
        6031
    ],
    "pampango": [
        6030,
        6031
    ],
    "pampangueño": [
        6030,
        6031
    ],
    "paiute, northern": [
        6032
    ],
    "paiute": [
        6032,
        8023
    ],
    "paviotso": [
        6032
    ],
    "papiamento": [
        6033
    ],
    "papiam": [
        6033
    ],
    "papiamen": [
        6033
    ],
    "papiamentoe": [
        6033
    ],
    "papiamentu": [
        6033
    ],
    "parya": [
        6034
    ],
    "pbharya": [
        6034
    ],
    "panamint": [
        6035
    ],
    "panamint shoshone": [
        6035
    ],
    "papasena": [
        6036
    ],
    "palauan": [
        6037
    ],
    "pakaásnovos": [
        6038
    ],
    "pacaas-novos": [
        6038
    ],
    "pacahanovo": [
        6038
    ],
    "pacaás novos": [
        6038
    ],
    "pacaás": [
        6038
    ],
    "pakaa nova": [
        6038
    ],
    "pakaa": [
        6038
    ],
    "pakaanova": [
        6038
    ],
    "pakaanovas": [
        6038
    ],
    "pawnee": [
        6039
    ],
    "pankararé": [
        6040
    ],
    "pankaré": [
        6040
    ],
    "pech": [
        6041
    ],
    "pesh": [
        6041
    ],
    "pankararú": [
        6042
    ],
    "pancaru": [
        6042
    ],
    "pancaré": [
        6042
    ],
    "pankarará": [
        6042
    ],
    "pankaravu": [
        6042
    ],
    "pankaroru": [
        6042
    ],
    "pankarú": [
        6042
    ],
    "páez": [
        6043
    ],
    "paes": [
        6043
    ],
    "popoloca, mezontla": [
        6045
    ],
    "popoloca": [
        6045,
        6046,
        6060,
        6197,
        6251,
        6265,
        6277
    ],
    "popoloca de mezontla": [
        6045
    ],
    "popoloca, coyotepec": [
        6046
    ],
    "paraujano": [
        6047
    ],
    "parahujano": [
        6047
    ],
    "panare": [
        6048
    ],
    "panari": [
        6048
    ],
    "parkwa": [
        6049
    ],
    "parǝkwa": [
        6049
    ],
    "parekwa": [
        6049
    ],
    "padogo": [
        6049
    ],
    "padoko": [
        6049
    ],
    "padokwa": [
        6049
    ],
    "paduko": [
        6049
    ],
    "pawdawkwa": [
        6049
    ],
    "podogo": [
        6049
    ],
    "podoko": [
        6049
    ],
    "podokwa": [
        6049
    ],
    "podokwo": [
        6049
    ],
    "panya": [
        6050
    ],
    "panyam": [
        6050
    ],
    "puebla mazatec": [
        6051
    ],
    "passam": [
        6052
    ],
    "papel": [
        6053
    ],
    "papei": [
        6053
    ],
    "pepel": [
        6053
    ],
    "pajade": [
        6054
    ],
    "pajadinca": [
        6054
    ],
    "pajadinka": [
        6054
    ],
    "pame, central": [
        6056
    ],
    "pame": [
        6056,
        6216,
        6223,
        6096
    ],
    "pame de santa maría acapulco": [
        6056
    ],
    "pame del centro": [
        6056
    ],
    "pashto, southern": [
        6057
    ],
    "pashto": [
        6057,
        6323,
        6307,
        6306
    ],
    "paktu": [
        6057,
        6306
    ],
    "pashtu": [
        6057,
        6306
    ],
    "pushto": [
        6306,
        6307,
        6057
    ],
    "pushtu": [
        6057
    ],
    "pnar": [
        6058
    ],
    "pyu": [
        6059,
        6390
    ],
    "pyu (papua new guinea)": [
        6059
    ],
    "popoloca, santa inés ahuatempan": [
        6060
    ],
    "popoloca de santa inés ahuatempan": [
        6060
    ],
    "popoloca del poniente": [
        6060,
        6265
    ],
    "poniente": [
        6060,
        6265,
        7303,
        8971
    ],
    "pear": [
        6061
    ],
    "por": [
        6061
    ],
    "pau thin": [
        6062,
        6063
    ],
    "pu-i": [
        6062,
        6063
    ],
    "pu-jui": [
        6062,
        6063
    ],
    "pu-nam": [
        6062,
        6063
    ],
    "pui": [
        6062,
        6063
    ],
    "pujai": [
        6062,
        6063
    ],
    "puyi": [
        6062,
        6063
    ],
    "puyoi": [
        6062,
        6063
    ],
    "pú nà": [
        6062,
        6063
    ],
    "pú": [
        6062,
        6063
    ],
    "picard": [
        6064
    ],
    "patois de nord": [
        6064
    ],
    "palaung, ruching": [
        6065
    ],
    "palaung": [
        6065,
        6066,
        6191,
        6486
    ],
    "palay": [
        6065,
        6066
    ],
    "pale": [
        6066,
        6065
    ],
    "pale palaung": [
        6065
    ],
    "pulei": [
        6065
    ],
    "palaung, pale": [
        6066
    ],
    "paliyan": [
        6067
    ],
    "paliyar": [
        6067
    ],
    "palani": [
        6067
    ],
    "palaya": [
        6067
    ],
    "palayan": [
        6067
    ],
    "palleyan": [
        6067
    ],
    "palliyar": [
        6067
    ],
    "poliyar": [
        6067
    ],
    "paniya": [
        6068,
        6069,
        6070
    ],
    "pania": [
        6068,
        6069,
        6070
    ],
    "paniyan": [
        6068,
        6069,
        6070
    ],
    "panyah": [
        6068,
        6069,
        6070
    ],
    "pardhan": [
        6071
    ],
    "pradhan": [
        6071
    ],
    "pradhani": [
        6071
    ],
    "parenga": [
        6074
    ],
    "pareng": [
        6074
    ],
    "parenga parja": [
        6074
    ],
    "parengi": [
        6074
    ],
    "parenji": [
        6074
    ],
    "paite": [
        6075
    ],
    "paite chin": [
        6075
    ],
    "paithe": [
        6075
    ],
    "parte": [
        6075
    ],
    "pardhi": [
        6076
    ],
    "paidia": [
        6076
    ],
    "paradhi": [
        6076
    ],
    "paradi": [
        6076
    ],
    "paria": [
        6076
    ],
    "phans pardhi": [
        6076
    ],
    "phans": [
        6076
    ],
    "pidgin, nigerian": [
        6077
    ],
    "piti": [
        6078,
        7064
    ],
    "pitti": [
        6078
    ],
    "pacahuara": [
        6079
    ],
    "pacawara": [
        6079
    ],
    "piapung": [
        6080
    ],
    "piapum": [
        6080
    ],
    "pirpum": [
        6080
    ],
    "pyapun": [
        6080
    ],
    "pyapung": [
        6080
    ],
    "pondoma": [
        6081
    ],
    "pennsylvania": [
        6082
    ],
    "pennsilfaanisch deitsch": [
        6082
    ],
    "pennsilfaanisch": [
        6082
    ],
    "pennsilfaani-deitsch": [
        6082
    ],
    "pennsylfaanisch deitsch": [
        6082
    ],
    "pennsylfaanisch": [
        6082
    ],
    "pennsylvaanisch deitsch": [
        6082
    ],
    "pennsylvaanisch": [
        6082
    ],
    "pennsylvania deitsh": [
        6082
    ],
    "pennsylvania dutch": [
        6082
    ],
    "pennsylvania german": [
        6082
    ],
    "pennsylvanisch": [
        6082
    ],
    "pennsylvanisch-deitsch": [
        6082
    ],
    "pennsylvanish": [
        6082
    ],
    "pa di": [
        6083
    ],
    "padi": [
        6083
    ],
    "podena": [
        6084
    ],
    "padoe": [
        6085
    ],
    "pado-e": [
        6085
    ],
    "padoé": [
        6085
    ],
    "plautdietsch": [
        6086
    ],
    "peranakan indonesian": [
        6089
    ],
    "pomo, eastern": [
        6090
    ],
    "pay": [
        6091
    ],
    "petapa": [
        9124,
        6092
    ],
    "pomo, northeastern": [
        6093
    ],
    "pengu": [
        6094
    ],
    "paoan": [
        6095
    ],
    "paonang": [
        6095
    ],
    "pame de chichimeca-jonaz": [
        6096
    ],
    "pomo, northern": [
        6097
    ],
    "penchal": [
        6098
    ],
    "pekal": [
        6099
    ],
    "phende": [
        6100
    ],
    "pende": [
        6100
    ],
    "pheende": [
        6100
    ],
    "pinji": [
        6144,
        6100
    ],
    "peremka": [
        6102
    ],
    "pomo, southern": [
        6103
    ],
    "pémono": [
        6104
    ],
    "petats": [
        6105
    ],
    "petjo": [
        6106
    ],
    "pecok": [
        6106
    ],
    "peco’": [
        6106
    ],
    "petjoh": [
        6106
    ],
    "penan, eastern": [
        6107
    ],
    "penan": [
        6107,
        6227,
        6224
    ],
    "pááfang": [
        6108
    ],
    "patapori": [
        6109
    ],
    "peer": [
        6109
    ],
    "peere": [
        6109
    ],
    "potopo": [
        6109
    ],
    "potopore": [
        6109
    ],
    "palatinate franconian": [
        6110
    ],
    "palatinate": [
        6110
    ],
    "plàtt": [
        6110
    ],
    "palatine german": [
        6110
    ],
    "palatine": [
        6110
    ],
    "pfaelzisch": [
        6110
    ],
    "pfälzisch": [
        6110
    ],
    "pfälzische": [
        6110
    ],
    "pälzisch": [
        6110
    ],
    "pidgin arabic": [
        6111
    ],
    "pangwali": [
        6113
    ],
    "pangi": [
        6113
    ],
    "pangwali pahari": [
        6113
    ],
    "pagi": [
        6114,
        8670,
        8671,
        8672
    ],
    "pagei": [
        6114
    ],
    "pangkumu": [
        6115
    ],
    "pangkumu bay": [
        6115
    ],
    "primitive irish": [
        6116
    ],
    "primitive": [
        6116
    ],
    "paelignian": [
        6117
    ],
    "pangseng": [
        6118
    ],
    "pago": [
        6119
    ],
    "pagoe": [
        6119
    ],
    "papua new guinean sign language": [
        6120
    ],
    "pngsl": [
        6120
    ],
    "pa-hng": [
        6121
    ],
    "pa hng": [
        6121
    ],
    "pa ngng": [
        6121
    ],
    "pa then": [
        6121
    ],
    "paheng": [
        6121
    ],
    "pà hung": [
        6121
    ],
    "pà": [
        6121
    ],
    "pà then": [
        6121
    ],
    "phudagi": [
        6122
    ],
    "phuong": [
        6123
    ],
    "phuang": [
        6123
    ],
    "phuong catang": [
        6123
    ],
    "phu kha": [
        6124
    ],
    "phu khla": [
        6124
    ],
    "phu la": [
        6124
    ],
    "phukha": [
        6124
    ],
    "phù lá": [
        6124
    ],
    "phù": [
        6124
    ],
    "phù lá hán": [
        6124
    ],
    "phake": [
        6125
    ],
    "phakey": [
        6125
    ],
    "phakial": [
        6125
    ],
    "palula": [
        6126
    ],
    "palola": [
        6126
    ],
    "phalulo": [
        6126
    ],
    "phalura": [
        6126
    ],
    "phimbi": [
        6127
    ],
    "pimbi": [
        6127
    ],
    "phoenician": [
        6128
    ],
    "phunoi": [
        6129
    ],
    "phounoy": [
        6129
    ],
    "phu noi": [
        6129
    ],
    "punoi": [
        6129
    ],
    "phana’": [
        6130
    ],
    "pana’": [
        6130
    ],
    "phana'": [
        6130
    ],
    "pahari-potwari": [
        6131
    ],
    "pahari-pothowari": [
        6131
    ],
    "pothohari": [
        6131
    ],
    "potohari": [
        6131
    ],
    "potwari": [
        6131
    ],
    "phu thai": [
        6132
    ],
    "phutai": [
        6132
    ],
    "phuu thai": [
        6132
    ],
    "phuu": [
        6132
    ],
    "poutai": [
        6132
    ],
    "puthai": [
        6132
    ],
    "puthay": [
        6132
    ],
    "phuan": [
        6133,
        6134,
        6135
    ],
    "phuon": [
        6133,
        6135
    ],
    "phoan": [
        6133,
        6135
    ],
    "phu un": [
        6133,
        6134,
        6135
    ],
    "phu-uen": [
        6133,
        6135
    ],
    "poan": [
        6133,
        6135
    ],
    "puan": [
        6133,
        6135
    ],
    "pahlavani": [
        6136
    ],
    "phangduwali": [
        6137
    ],
    "phangduvali": [
        6137
    ],
    "phangduwali poti": [
        6137
    ],
    "poti": [
        6137
    ],
    "pima bajo": [
        6142
    ],
    "pima": [
        6142,
        6364
    ],
    "pira": [
        6143
    ],
    "pinzi": [
        6144
    ],
    "piaroa": [
        6145
    ],
    "piaroa-mako": [
        6145
    ],
    "pingelapese": [
        6147
    ],
    "pingelap": [
        6147
    ],
    "pingilapese": [
        6147
    ],
    "pisabo": [
        6148
    ],
    "pisagua": [
        6148
    ],
    "pisahua": [
        6148
    ],
    "pitcairn-norfolk": [
        6149
    ],
    "pitcairn english": [
        6149
    ],
    "pini": [
        6150
    ],
    "pandjanu": [
        6150
    ],
    "piniiri": [
        6150
    ],
    "piniridjara": [
        6150
    ],
    "piniritjara": [
        6150
    ],
    "pirniritjara": [
        6150
    ],
    "pijao": [
        6151
    ],
    "piajao": [
        6151
    ],
    "pijao paniquita": [
        6151
    ],
    "paniquita": [
        6151
    ],
    "pijao paniquitá": [
        6151
    ],
    "paniquitá": [
        6151
    ],
    "pinao": [
        6151
    ],
    "pixao": [
        6151
    ],
    "pila": [
        6152,
        6931
    ],
    "pilapila": [
        6152
    ],
    "powhatan": [
        6153
    ],
    "piapoco": [
        6155
    ],
    "piapoko": [
        6155
    ],
    "piapoko dejá": [
        6155
    ],
    "pero": [
        6156
    ],
    "pipero": [
        6156
    ],
    "piratapuyo": [
        6157
    ],
    "pira-tapuia": [
        6157
    ],
    "pira-tapuya": [
        6157
    ],
    "piratapuia": [
        6157
    ],
    "piratapuya": [
        6157
    ],
    "pijin": [
        6158
    ],
    "pita pita": [
        6159
    ],
    "pita": [
        6159
    ],
    "pitha-pitha": [
        6159
    ],
    "pintupi-luritja": [
        6160
    ],
    "pintubi": [
        6160
    ],
    "pintupi": [
        6160
    ],
    "pileni": [
        6161
    ],
    "pilheni": [
        6161
    ],
    "pimbwe": [
        6162
    ],
    "piu": [
        6163
    ],
    "piya-kwonci": [
        6164
    ],
    "piya": [
        6164
    ],
    "pije": [
        6165
    ],
    "pindje": [
        6165
    ],
    "pinje": [
        6165
    ],
    "pitjantjatjara": [
        6166
    ],
    "pitjantjara": [
        6166
    ],
    "pitjantjatjarra": [
        6166
    ],
    "prākrit": [
        6167,
        6208,
        6324,
        6325
    ],
    "pokomo": [
        6168
    ],
    "pfokomo": [
        6168
    ],
    "paekche": [
        6169
    ],
    "pak-tong": [
        6170
    ],
    "pangkhua": [
        6171,
        6172
    ],
    "paang": [
        6171,
        6172
    ],
    "pang": [
        6171,
        6172
    ],
    "pang khua": [
        6171,
        6172
    ],
    "pangkhu": [
        6171,
        6172
    ],
    "pankho": [
        6171,
        6172
    ],
    "pankhu": [
        6171,
        6172
    ],
    "pankhua": [
        6171,
        6172
    ],
    "panko": [
        6171,
        6172
    ],
    "pankua": [
        6171,
        6172
    ],
    "pakanha": [
        6173
    ],
    "pakanh": [
        6173
    ],
    "pökoot": [
        6174
    ],
    "pakot": [
        6174
    ],
    "pokot": [
        6174
    ],
    "pökot": [
        6174
    ],
    "pukapuka": [
        6175
    ],
    "pukapukan": [
        6175
    ],
    "pal kurumba": [
        6176,
        8669
    ],
    "pakistan sign language": [
        6177
    ],
    "psl": [
        6177
    ],
    "polish": [
        6180,
        6181,
        6318,
        6542
    ],
    "polski": [
        6180,
        6318
    ],
    "polnisch": [
        6180,
        6181
    ],
    "polština": [
        6180,
        6181
    ],
    "polonombauk": [
        6183
    ],
    "palawano, central": [
        6184
    ],
    "palawano": [
        6184,
        6199,
        6200
    ],
    "palawanen": [
        6184
    ],
    "palaweño": [
        6184,
        6200
    ],
    "polari": [
        6185
    ],
    "palari": [
        6185
    ],
    "palarie": [
        6185
    ],
    "parlare": [
        6185
    ],
    "parlaree": [
        6185
    ],
    "parlary": [
        6185
    ],
    "parlyaree": [
        6185
    ],
    "palu’e": [
        6186
    ],
    "palu'e": [
        6186
    ],
    "palue": [
        6186
    ],
    "paluqe": [
        6186
    ],
    "pilagá": [
        6187
    ],
    "pilaca": [
        6187
    ],
    "paulohi": [
        6188
    ],
    "polci": [
        6189
    ],
    "palchi": [
        6189
    ],
    "palci": [
        6189
    ],
    "polchi": [
        6189
    ],
    "palasi-kohistani": [
        6190
    ],
    "palaung, shwe": [
        6191
    ],
    "palenquero": [
        6192
    ],
    "palenque": [
        6192
    ],
    "popoluca, oluta": [
        6193
    ],
    "popoluca": [
        6193,
        6255,
        6261,
        6262,
        6197
    ],
    "popoluca de oluta": [
        6193
    ],
    "palpa": [
        6194
    ],
    "palaic": [
        6195
    ],
    "palaka": [
        6196
    ],
    "palaka senoufo": [
        6196
    ],
    "palara": [
        6196
    ],
    "pallakha": [
        6196
    ],
    "pilara": [
        6196
    ],
    "popoloca, san marcos tlacoyalco": [
        6197
    ],
    "popoloca de san marcos tlalcoyalco": [
        6197
    ],
    "popoluca del norte": [
        6197
    ],
    "palikúr": [
        6198
    ],
    "pa'ikwaki": [
        6198
    ],
    "paikwene": [
        6198
    ],
    "palicur": [
        6198
    ],
    "palijur": [
        6198
    ],
    "palikour": [
        6198
    ],
    "paliku’ene": [
        6198
    ],
    "palincur": [
        6198
    ],
    "paricores": [
        6198
    ],
    "paricuria": [
        6198
    ],
    "parikurene": [
        6198
    ],
    "parinkur-lene": [
        6198
    ],
    "pa’ikwaki": [
        6198
    ],
    "palawano, southwest": [
        6199
    ],
    "palawano, brooke’s point": [
        6200
    ],
    "palawanun": [
        6200
    ],
    "pelaꞌwan": [
        6200
    ],
    "pelewan": [
        6200
    ],
    "pinalawan": [
        6200
    ],
    "pinelawan": [
        6200
    ],
    "paliu": [
        6201
    ],
    "palju": [
        6201
    ],
    "palyu": [
        6201
    ],
    "polyu": [
        6201
    ],
    "paluan": [
        6202
    ],
    "paama": [
        6203
    ],
    "paama-lopevi": [
        6203
    ],
    "paamese": [
        6203
    ],
    "pauma": [
        6203
    ],
    "pambia": [
        6204
    ],
    "pallanganmiddang": [
        6205
    ],
    "pallangahmiddang": [
        6205
    ],
    "pwaamei": [
        6206
    ],
    "poamei": [
        6206
    ],
    "pwamei": [
        6206
    ],
    "pamona": [
        6207
    ],
    "poso": [
        6207
    ],
    "pumi, northern": [
        6209
    ],
    "pumi": [
        6209,
        6210
    ],
    "pimi": [
        6209,
        6210
    ],
    "primmi": [
        6209,
        6210
    ],
    "pruumi": [
        6209,
        6210
    ],
    "p’rome": [
        6209,
        6210
    ],
    "p’umi": [
        6209,
        6210
    ],
    "p’ömi": [
        6209,
        6210
    ],
    "pumi, southern": [
        6210
    ],
    "prinmi": [
        6210
    ],
    "pamlico": [
        6211
    ],
    "petit mauresque": [
        6212
    ],
    "petit": [
        6212
    ],
    "pol": [
        6213
    ],
    "pori": [
        6213
    ],
    "pul": [
        6213
    ],
    "pólrì": [
        6213
    ],
    "pam": [
        6214
    ],
    "pom": [
        6215
    ],
    "pame, northern": [
        6216
    ],
    "pame del norte": [
        6216
    ],
    "paynamar": [
        6217
    ],
    "piedmontese": [
        6218
    ],
    "piamontés": [
        6218
    ],
    "piemontese": [
        6218
    ],
    "piemontèis": [
        6218
    ],
    "paumotu": [
        6219
    ],
    "pa’umotu": [
        6219
    ],
    "plains miwok": [
        6220
    ],
    "poumai": [
        6221
    ],
    "paola": [
        6221,
        8792
    ],
    "paumei": [
        6221
    ],
    "pomai": [
        6221
    ],
    "pome": [
        6221
    ],
    "poula": [
        6221
    ],
    "poumei": [
        6221
    ],
    "poumei naga": [
        6221
    ],
    "papuan": [
        6222
    ],
    "papuan malay": [
        6222
    ],
    "pame, southern": [
        6223
    ],
    "pamean": [
        6223
    ],
    "punan bah-biau": [
        6224
    ],
    "pannei": [
        6225
    ],
    "panei": [
        6225
    ],
    "penan, western": [
        6227
    ],
    "pangu": [
        6228
    ],
    "panganci": [
        6228
    ],
    "pongu": [
        6228
    ],
    "penrhyn": [
        6229
    ],
    "penrhynese": [
        6229
    ],
    "penihing": [
        6230
    ],
    "pinjarup": [
        6231
    ],
    "peejine": [
        6231
    ],
    "penjarra": [
        6231
    ],
    "pidjain": [
        6231
    ],
    "pindjarup": [
        6231
    ],
    "pinjarra": [
        6231
    ],
    "paunaka": [
        6232
    ],
    "pauna": [
        6232
    ],
    "paunaca": [
        6232
    ],
    "paleni": [
        6233
    ],
    "punan batu": [
        6234
    ],
    "punan batu 1": [
        6234
    ],
    "pinai-hagahai": [
        6235
    ],
    "pinai": [
        6235
    ],
    "pinaye": [
        6235
    ],
    "panobo": [
        6236
    ],
    "pelado": [
        6236
    ],
    "pancana": [
        6237
    ],
    "pantjana": [
        6237
    ],
    "pana (burkina faso)": [
        6238
    ],
    "panim": [
        6239
    ],
    "ponosakan": [
        6240
    ],
    "ponasakan": [
        6240
    ],
    "ponosakansch": [
        6240
    ],
    "pontic": [
        6241,
        6242,
        6243
    ],
    "pontic greek": [
        6241,
        6242,
        6243
    ],
    "pinigura": [
        6245
    ],
    "pinikura": [
        6245
    ],
    "pandjima": [
        6246
    ],
    "panjima": [
        6246
    ],
    "panjtjima": [
        6246
    ],
    "panyima": [
        6246
    ],
    "panyjima": [
        6246
    ],
    "panytyima": [
        6246
    ],
    "phong-kniang": [
        6247
    ],
    "pinyin": [
        6248,
        8186
    ],
    "pìnyinə": [
        6248
    ],
    "pelimpo": [
        6248
    ],
    "pana (central african republic)": [
        6249
    ],
    "poqomam": [
        6250
    ],
    "pocomán": [
        6250
    ],
    "pokomam": [
        6250
    ],
    "popoloca, san juan atzingo": [
        6251
    ],
    "popoloca de san juan atzingo": [
        6251
    ],
    "popoloca del oriente": [
        6251
    ],
    "pfoke": [
        6252
    ],
    "puki": [
        6252
    ],
    "potiguára": [
        6253
    ],
    "petigaré": [
        6253
    ],
    "pitonara": [
        6253
    ],
    "potiguara": [
        6253
    ],
    "potyguara": [
        6253
    ],
    "poqomchi’": [
        6254
    ],
    "poqonchi": [
        6254
    ],
    "pocomchí": [
        6254
    ],
    "poconchí": [
        6254
    ],
    "pokomchí": [
        6254
    ],
    "pokonchí": [
        6254
    ],
    "poqomchi'": [
        6254
    ],
    "popoluca, highland": [
        6255
    ],
    "popoluca de la sierra": [
        6255
    ],
    "pokangá": [
        6256
    ],
    "pakang": [
        6256
    ],
    "panenoá": [
        6256
    ],
    "pokangá-tapuya": [
        6256
    ],
    "pãnerã": [
        6256
    ],
    "pomo, southeastern": [
        6257
    ],
    "pohnpeian": [
        6258
    ],
    "pohnpei": [
        6258
    ],
    "ponapean": [
        6258
    ],
    "pomo, central": [
        6259
    ],
    "pwapwâ": [
        6260
    ],
    "poapoa": [
        6260
    ],
    "pwapwa": [
        6260
    ],
    "popoluca, texistepec": [
        6261
    ],
    "popoluca, sayula": [
        6262
    ],
    "potawatomi": [
        6263
    ],
    "pottawotomi": [
        6263
    ],
    "pottawottomi": [
        6263
    ],
    "portuguese creole": [
        6264
    ],
    "popoloca, san felipe otlaltepec": [
        6265
    ],
    "popoloca de san felipe otlaltepec": [
        6265
    ],
    "polabian": [
        6266
    ],
    "pogolo": [
        6267
    ],
    "pogolu": [
        6267
    ],
    "pogora": [
        6267
    ],
    "pogoro": [
        6267
    ],
    "papi": [
        6268
    ],
    "paupe": [
        6268
    ],
    "paipai": [
        6269
    ],
    "pipikoro": [
        6270
    ],
    "papuma": [
        6272
    ],
    "papapana": [
        6273
    ],
    "podoba": [
        6274
    ],
    "podopa": [
        6274
    ],
    "polopa": [
        6274
    ],
    "pelende": [
        6275
    ],
    "pefiyahe": [
        6276
    ],
    "popoloca, san luís temalacayuca": [
        6277
    ],
    "popoloca de san luis temalacayuca": [
        6277
    ],
    "papora-hoanya": [
        6279
    ],
    "papola": [
        6279
    ],
    "papora": [
        6279
    ],
    "pa’a": [
        6280
    ],
    "pa'a": [
        6280
    ],
    "pa’anci": [
        6280
    ],
    "pa’awa": [
        6280
    ],
    "peskotomuhkati wolastoqewi latuwewakon": [
        6281
    ],
    "peskotomuhkati": [
        6281
    ],
    "prakrit languages": [
        6282
    ],
    "prakrit": [
        6282
    ],
    "parachi": [
        6284
    ],
    "parsi-dari": [
        6285
    ],
    "parsee": [
        6285,
        6296
    ],
    "parsee-dari": [
        6285
    ],
    "principense": [
        6286
    ],
    "paranan": [
        6287
    ],
    "palanenyo": [
        6287
    ],
    "prussian": [
        6288
    ],
    "prūsiskan": [
        6288
    ],
    "prūsiskai": [
        6288
    ],
    "porohanon": [
        6289
    ],
    "paicî": [
        6290
    ],
    "paaci": [
        6290
    ],
    "pati": [
        6290
    ],
    "ponerihouen": [
        6290
    ],
    "parauk": [
        6291
    ],
    "phalok": [
        6291
    ],
    "praok": [
        6291
    ],
    "peruvian sign language": [
        6292
    ],
    "peruvian": [
        6292
    ],
    "peruana": [
        6292
    ],
    "peruano": [
        6292
    ],
    "polome": [
        6293
    ],
    "porome": [
        6293
    ],
    "prasuni": [
        6294
    ],
    "parun": [
        6294
    ],
    "paruni": [
        6294
    ],
    "prasun": [
        6294
    ],
    "perené": [
        6297
    ],
    "perené ashéninca": [
        6297
    ],
    "puri": [
        6298
    ],
    "paquí": [
        6298
    ],
    "prai": [
        6300
    ],
    "phai": [
        6300
    ],
    "pray": [
        6300
    ],
    "puragi": [
        6301
    ],
    "parawen": [
        6302
    ],
    "purig": [
        6303,
        6304
    ],
    "purig-pa": [
        6303,
        6304
    ],
    "purigskad": [
        6303,
        6304
    ],
    "purik": [
        6303,
        6304
    ],
    "purik bhotia": [
        6303,
        6304
    ],
    "purkhi": [
        6303,
        6304
    ],
    "purki": [
        6303,
        6304
    ],
    "providencia sign language": [
        6305
    ],
    "providencia": [
        6305
    ],
    "pakhto": [
        6306
    ],
    "pakhtoo": [
        6306
    ],
    "pakhtoon": [
        6306
    ],
    "pakhtun": [
        6306
    ],
    "pashto, northern": [
        6306
    ],
    "pashtoon": [
        6306
    ],
    "passtoo": [
        6306
    ],
    "pusto": [
        6306
    ],
    "pisa": [
        6308
    ],
    "persian sign language": [
        6309
    ],
    "plains indian sign language": [
        6310
    ],
    "pisl": [
        6310
    ],
    "pst": [
        6310
    ],
    "plains sign language": [
        6310
    ],
    "plains sign talk": [
        6310
    ],
    "pasemah": [
        6311
    ],
    "penang sign language": [
        6312
    ],
    "penang": [
        6312
    ],
    "pashai, southwest": [
        6313
    ],
    "pashai, southeast": [
        6314
    ],
    "puerto rican sign language": [
        6315
    ],
    "prsl": [
        6315
    ],
    "pauserna": [
        6316
    ],
    "paucerne": [
        6316
    ],
    "pauserna-guarasugwé": [
        6316
    ],
    "panasuan": [
        6317
    ],
    "pamosean": [
        6317
    ],
    "panasean": [
        6317
    ],
    "polish sign language": [
        6318
    ],
    "pjm": [
        6318
    ],
    "polski język migowy": [
        6318
    ],
    "philippine sign language": [
        6319
    ],
    "philippine": [
        6319
    ],
    "pasi": [
        6320
    ],
    "portuguese sign language": [
        6321
    ],
    "portuguesa": [
        6321
    ],
    "pasismanua": [
        6322
    ],
    "pashto, central": [
        6323
    ],
    "port sandwich": [
        6326
    ],
    "port": [
        6326,
        6351,
        8598
    ],
    "piscataway": [
        6327
    ],
    "portugais": [
        6328,
        6330
    ],
    "portugués": [
        6328,
        6330
    ],
    "portugués del uruguay": [
        6328,
        6330
    ],
    "portunhol": [
        6328,
        6330
    ],
    "portuñol": [
        6328,
        6330
    ],
    "purtagaalee": [
        6328,
        6330
    ],
    "português europeu": [
        6338
    ],
    "pai tavytera": [
        6341
    ],
    "pai tavyterã": [
        6341
    ],
    "pataxó hã-ha-hãe": [
        6342
    ],
    "pataxó": [
        6342
    ],
    "patashó": [
        6342
    ],
    "pataxi": [
        6342
    ],
    "pataxó-hãhaãi": [
        6342
    ],
    "patoxó": [
        6342
    ],
    "pintiini": [
        6343
    ],
    "pindiini": [
        6343
    ],
    "patani": [
        6344
    ],
    "poturu": [
        6345
    ],
    "poturujara": [
        6345
    ],
    "puturú": [
        6345
    ],
    "patep": [
        6346
    ],
    "ptep": [
        6346
    ],
    "pattapu": [
        6347
    ],
    "pattapu bhasha": [
        6347
    ],
    "piamatsina": [
        6348
    ],
    "pitu uluna salu": [
        6350
    ],
    "pitu": [
        6350
    ],
    "pitu-ulunna-salu": [
        6350
    ],
    "port vato": [
        6351
    ],
    "pentlatch": [
        6352
    ],
    "pathiya": [
        6353
    ],
    "purepecha, western highland": [
        6354
    ],
    "purepecha": [
        6354,
        7752
    ],
    "purépecha": [
        6354,
        7752
    ],
    "purépecha de la meseta": [
        6354
    ],
    "purépecha de las sierras": [
        6354
    ],
    "purépecha del oeste de sierra occidental": [
        6354
    ],
    "p’orhe": [
        6354,
        7752
    ],
    "p’orhépecha": [
        6354,
        7752
    ],
    "p’urhe": [
        6354,
        7752
    ],
    "p’urhépecha": [
        6354,
        7752
    ],
    "purum": [
        6355
    ],
    "puram": [
        6355
    ],
    "purum naga": [
        6355
    ],
    "punan merap": [
        6356
    ],
    "punan aput": [
        6357
    ],
    "puelche": [
        6358
    ],
    "pampa": [
        6358
    ],
    "punan merah": [
        6359
    ],
    "phuie": [
        6360
    ],
    "phuien": [
        6360
    ],
    "phuó": [
        6360
    ],
    "pougouli": [
        6360
    ],
    "puguli": [
        6360
    ],
    "pwa": [
        6360
    ],
    "pwe": [
        6360
    ],
    "pwie": [
        6360
    ],
    "pwien": [
        6360
    ],
    "puinave": [
        6361
    ],
    "puinabe": [
        6361
    ],
    "puinare": [
        6361
    ],
    "punan tubu": [
        6362
    ],
    "pu ko": [
        6363
    ],
    "puma": [
        6364,
        7553,
        8838
    ],
    "puma kala": [
        6364
    ],
    "puma la": [
        6364
    ],
    "puma pima": [
        6364
    ],
    "puoc": [
        6365
    ],
    "puhoc": [
        6365
    ],
    "pou hok": [
        6365
    ],
    "pou": [
        6365
    ],
    "pua": [
        6365
    ],
    "puok": [
        6365
    ],
    "pulabu": [
        6366
    ],
    "puruborá": [
        6368
    ],
    "pumbora": [
        6368
    ],
    "puroborá": [
        6368
    ],
    "puruba": [
        6368
    ],
    "putoh": [
        6369
    ],
    "pouno": [
        6370
    ],
    "pounou": [
        6370
    ],
    "puno": [
        6442,
        6370
    ],
    "puluwatese": [
        6371
    ],
    "puluwat": [
        6371
    ],
    "puare": [
        6372
    ],
    "purisimeño": [
        6373
    ],
    "purisima": [
        6373
    ],
    "purismeño": [
        6373
    ],
    "purísima": [
        6373
    ],
    "pawaia": [
        6374
    ],
    "pavaia": [
        6374
    ],
    "pawaian": [
        6374
    ],
    "panawa": [
        6375
    ],
    "patwin": [
        6377
    ],
    "paiwan": [
        6379
    ],
    "paiuan": [
        6379
    ],
    "payowan": [
        6379
    ],
    "pinayuanan": [
        6379
    ],
    "pathein pwo karen": [
        6380
    ],
    "pathein": [
        6380
    ],
    "phlong sho": [
        6380
    ],
    "pwo western karen": [
        6380
    ],
    "powari": [
        6381
    ],
    "pwari": [
        6381
    ],
    "phlon": [
        6382
    ],
    "pwo northern karen": [
        6382
    ],
    "pye krumen": [
        6384
    ],
    "pyam": [
        6385
    ],
    "paiem": [
        6385
    ],
    "pem": [
        6385
    ],
    "pyem": [
        6385
    ],
    "poyanáwa": [
        6386
    ],
    "poianáua": [
        6386
    ],
    "puinahua": [
        6386
    ],
    "paraguayan sign language": [
        6387
    ],
    "paraguaya": [
        6387
    ],
    "puyuma": [
        6388,
        6389
    ],
    "panapanayan": [
        6388,
        6389
    ],
    "pelam": [
        6388,
        6389
    ],
    "pilam": [
        6388,
        6389
    ],
    "pinuyumayan": [
        6388,
        6389
    ],
    "piyuma": [
        6388,
        6389
    ],
    "pyuma": [
        6388,
        6389
    ],
    "pyu (myanmar)": [
        6390
    ],
    "pyen": [
        6391
    ],
    "phen": [
        6391,
        7878
    ],
    "pyin": [
        6391
    ],
    "para naga": [
        6392
    ],
    "parasar naga": [
        6392
    ],
    "parasar": [
        6392
    ],
    "pichincha quichua": [
        6399
    ],
    "pichincha": [
        6399
    ],
    "paz": [
        6404
    ],
    "pastaza": [
        6407,
        6429
    ],
    "pasco": [
        6446,
        6409
    ],
    "pacaraos": [
        6425
    ],
    "pacaraos quechua": [
        6425
    ],
    "pastaza quichua": [
        6429
    ],
    "panao": [
        6438
    ],
    "pachitea quechua": [
        6438
    ],
    "pachitea": [
        6438
    ],
    "panao huánuco quechua": [
        6438
    ],
    "panao runacuna": [
        6438
    ],
    "pomabamba": [
        6440
    ],
    "puno quechua": [
        6442
    ],
    "provincia": [
        6444
    ],
    "puk": [
        6454
    ],
    "pûk": [
        6454
    ],
    "pahavai": [
        6465
    ],
    "pelipowai": [
        6465
    ],
    "pohuai": [
        6465
    ],
    "pascuense": [
        6470
    ],
    "palaung, rumai": [
        6486
    ],
    "perapa-perapa": [
        6489
    ],
    "phaan bhaasaa": [
        6530
    ],
    "phaan": [
        6530
    ],
    "phaan boli": [
        6530
    ],
    "polia": [
        6537
    ],
    "para-romani": [
        6544
    ],
    "pogadi chib": [
        6544
    ],
    "pogadi": [
        6544
    ],
    "posh ‘n’ posh": [
        6544
    ],
    "posh": [
        6544
    ],
    "posha": [
        6548
    ],
    "pasan": [
        6606
    ],
    "panara": [
        6644
    ],
    "puruwantung": [
        6644
    ],
    "ponorwol": [
        6685
    ],
    "palkar": [
        6687,
        6688,
        6689,
        6690
    ],
    "patnuli": [
        6687,
        6688,
        6689,
        6690
    ],
    "padong": [
        6733
    ],
    "padong khmer": [
        6733
    ],
    "pehlewaní": [
        6753
    ],
    "pahan": [
        6762,
        6763,
        6764
    ],
    "pwata": [
        6796
    ],
    "pai coca": [
        6797,
        7004
    ],
    "pãi": [
        6797
    ],
    "pai koka": [
        6797
    ],
    "paikoka": [
        6797
    ],
    "pãi kokua": [
        6797
    ],
    "paasaal": [
        6872
    ],
    "pasaal": [
        6872
    ],
    "pasaale": [
        6872
    ],
    "pasaale sisaala": [
        6872
    ],
    "peng": [
        6874
    ],
    "pedede": [
        6889
    ],
    "pite": [
        6892
    ],
    "pite sami": [
        6892
    ],
    "pellun mapun": [
        6896
    ],
    "pellun": [
        6896
    ],
    "pullun mapun": [
        6896
    ],
    "pullun": [
        6896
    ],
    "pewanean": [
        6924
    ],
    "pewaneang": [
        6924
    ],
    "pohoneang": [
        6924
    ],
    "pangutaran": [
        6950
    ],
    "pangutaran sama": [
        6950
    ],
    "pela’u": [
        6972
    ],
    "pala’u": [
        6972
    ],
    "pioche-sioni": [
        7004
    ],
    "piohé": [
        7004
    ],
    "pioje": [
        7004
    ],
    "pioje-sioni": [
        7004
    ],
    "pak tai": [
        7043
    ],
    "pak": [
        7043
    ],
    "pak thai": [
        7043
    ],
    "paktay": [
        7043
    ],
    "piti bhoti": [
        7064
    ],
    "paiter": [
        7120
    ],
    "phuthi": [
        7127
    ],
    "priangan": [
        7183,
        7184,
        7185,
        7186
    ],
    "puroik": [
        7202,
        7203,
        7204
    ],
    "pirthwar": [
        7208
    ],
    "posunkovej": [
        7219
    ],
    "pachien": [
        7262
    ],
    "paichien": [
        7262
    ],
    "pongso no tao": [
        7314
    ],
    "pongso": [
        7314
    ],
    "pamoa": [
        7321
    ],
    "pizin": [
        7371
    ],
    "panchpargania": [
        7382,
        7383,
        7384
    ],
    "pan sawasi": [
        7382,
        7383,
        7384
    ],
    "petel": [
        7400
    ],
    "podra": [
        7401
    ],
    "prasa": [
        7403
    ],
    "praça": [
        7403
    ],
    "pie": [
        7409
    ],
    "patagón": [
        7416
    ],
    "piva": [
        7453
    ],
    "phon soung": [
        7477
    ],
    "phonsung": [
        7477
    ],
    "panchgaunle": [
        7483
    ],
    "pi tsi kha": [
        7522
    ],
    "pi": [
        7522
    ],
    "pirtkopannoot": [
        7531
    ],
    "punoinjon": [
        7531
    ],
    "purteetchally": [
        7531
    ],
    "portugis": [
        7593
    ],
    "pakewa": [
        7631
    ],
    "plateau tonga": [
        7645
    ],
    "papantla": [
        7650
    ],
    "papantla totonac": [
        7650
    ],
    "pisin": [
        7666
    ],
    "paw": [
        7672
    ],
    "pisaflores": [
        7673
    ],
    "pisaflores tepehua": [
        7673
    ],
    "proon": [
        7677
    ],
    "proons": [
        7677
    ],
    "pinche": [
        7717
    ],
    "pinchi": [
        7717
    ],
    "pamung sug": [
        7734,
        7735
    ],
    "pamung": [
        7734,
        7735
    ],
    "phorhépecha": [
        7752
    ],
    "porhé": [
        7752
    ],
    "purépecha de la zona lacustre": [
        7752
    ],
    "p’orhepecha": [
        7752
    ],
    "p’urhepecha": [
        7752
    ],
    "ponek": [
        7760
    ],
    "pahkaanil": [
        7782
    ],
    "pahka’anil": [
        7782
    ],
    "pakaanil": [
        7782
    ],
    "pakanapul": [
        7782
    ],
    "payacú": [
        7786
    ],
    "penin": [
        7814
    ],
    "penyin": [
        7814
    ],
    "pidgin, timor": [
        7817
    ],
    "portuguese timor": [
        7817
    ],
    "português de bidau": [
        7817
    ],
    "pramipa": [
        7828
    ],
    "pa’da": [
        7835
    ],
    "paitan": [
        7839
    ],
    "put karot": [
        7857
    ],
    "put": [
        7857
    ],
    "pekhi": [
        7903,
        7904
    ],
    "paʔnnei": [
        7952
    ],
    "paungnyuan": [
        7963
    ],
    "pongnyun": [
        7963
    ],
    "pendau": [
        7967
    ],
    "pazeh": [
        8030
    ],
    "pazeh-kahabu": [
        8030
    ],
    "pazehe": [
        8030
    ],
    "pazih": [
        8030
    ],
    "pazzehe": [
        8030
    ],
    "puman": [
        8032
    ],
    "p’uman": [
        8032
    ],
    "paxala": [
        8048
    ],
    "pradesh": [
        8049
    ],
    "padwi bhilori": [
        8059,
        8060
    ],
    "padwi": [
        8059,
        8060
    ],
    "país": [
        8141
    ],
    "pute": [
        8145
    ],
    "parukota": [
        8171
    ],
    "peung sux": [
        8186
    ],
    "peung": [
        8186
    ],
    "pun": [
        8186
    ],
    "pwi": [
        8186
    ],
    "parahuri": [
        8194
    ],
    "patjtjamalh": [
        8198
    ],
    "pidgin, cameroon": [
        8212
    ],
    "perai": [
        8213
    ],
    "pretas": [
        8240
    ],
    "paranawat": [
        8240
    ],
    "pole vitu": [
        8242
    ],
    "pole matotoa": [
        8242
    ],
    "pyramid": [
        8268
    ],
    "pililuna": [
        8283
    ],
    "pereba": [
        8315
    ],
    "perema": [
        8315
    ],
    "parnkarra": [
        8323
    ],
    "paiyage": [
        8364
    ],
    "plains kachari": [
        8391
    ],
    "pusciti": [
        8409
    ],
    "pungandaitj": [
        8417
    ],
    "pungandik": [
        8417
    ],
    "pungantitj": [
        8417
    ],
    "pungatitj": [
        8417
    ],
    "peopleman": [
        8423
    ],
    "pepelman": [
        8423
    ],
    "pibilum": [
        8423
    ],
    "piblemen": [
        8423
    ],
    "patyala": [
        8426
    ],
    "pairi": [
        8459
    ],
    "palamul": [
        8553
    ],
    "petasia": [
        8555
    ],
    "pahari kangri": [
        8567
    ],
    "paljgu": [
        8571
    ],
    "palyku": [
        8571
    ],
    "pirriya": [
        8588
    ],
    "piria": [
        8588
    ],
    "pyemmairrener": [
        8589
    ],
    "pecheneg": [
        8590
    ],
    "phrygian": [
        8593
    ],
    "pictish": [
        8595
    ],
    "port sorell tasmanian": [
        8598
    ],
    "pumpokol": [
        8599
    ],
    "pochutec": [
        8601
    ],
    "puyo-paekche": [
        8602
    ],
    "parthian": [
        8604
    ],
    "pisidian": [
        8605
    ],
    "punthamara": [
        8606
    ],
    "puntamara": [
        8606
    ],
    "punic": [
        8607
    ],
    "peerapper": [
        8609
    ],
    "puyo": [
        8611
    ],
    "pablo": [
        8654,
        9169
    ],
    "peñasco": [
        8655
    ],
    "peñasco mixtec": [
        8655
    ],
    "piedras": [
        8658
    ],
    "paienbera": [
        8665
    ],
    "paiendra": [
        8665
    ],
    "peda": [
        8693
    ],
    "phera": [
        8693
    ],
    "pass": [
        8719
    ],
    "pass valley yali": [
        8719
    ],
    "pumé": [
        8721
    ],
    "pao tle": [
        8753
    ],
    "panjiri yerava": [
        8768,
        8769
    ],
    "panjiri": [
        8768,
        8769
    ],
    "pingtouyi": [
        8785
    ],
    "phowa, hlepho": [
        8792
    ],
    "phowa": [
        8792,
        8884,
        8888
    ],
    "pegullo-bura": [
        8799
    ],
    "pholo": [
        8805
    ],
    "pauwi": [
        8817
    ],
    "phulapha": [
        8819
    ],
    "parara": [
        8842
    ],
    "phulai": [
        8845
    ],
    "phulawa": [
        8845
    ],
    "pingtou phula": [
        8845
    ],
    "pingtou": [
        8845
    ],
    "palma": [
        8846,
        8847
    ],
    "phutsu": [
        8853
    ],
    "phala": [
        8883
    ],
    "phulepho": [
        8883,
        8885
    ],
    "phowa, labo": [
        8884
    ],
    "phola": [
        8885,
        8889
    ],
    "phupha": [
        8886,
        8890
    ],
    "phupho": [
        8886
    ],
    "phuma": [
        8887
    ],
    "paotlo": [
        8887
    ],
    "phuli": [
        8887
    ],
    "phowa, ani": [
        8888
    ],
    "phola, alo": [
        8889
    ],
    "phupa": [
        8890
    ],
    "phuza": [
        8891
    ],
    "phujitsu": [
        8891
    ],
    "phu’a": [
        8891
    ],
    "peninsular maya": [
        8919
    ],
    "peninsular": [
        8919
    ],
    "phang": [
        8923,
        8924,
        8925,
        8926
    ],
    "phúc": [
        8923,
        8924,
        8925,
        8926
    ],
    "phóng": [
        8923,
        8924,
        8925,
        8926
    ],
    "patsoka": [
        8929
    ],
    "purra": [
        8934
    ],
    "pekwan": [
        8937
    ],
    "paraene": [
        8944
    ],
    "parene": [
        8944
    ],
    "pomp-malkie": [
        8959
    ],
    "pallaganmiddah": [
        8960
    ],
    "panggarang": [
        8960
    ],
    "pérez": [
        8973
    ],
    "pochutla": [
        8992,
        9143,
        9165
    ],
    "phu nong": [
        9047,
        9048
    ],
    "phu tei": [
        9047,
        9048
    ],
    "puj daez": [
        9047,
        9048
    ],
    "puj": [
        9047,
        9048
    ],
    "puj noangz": [
        9047,
        9048
    ],
    "puj nuangz": [
        9047,
        9048
    ],
    "puteik": [
        9061
    ],
    "padnaindi": [
        9071
    ],
    "padnayndie": [
        9071
    ],
    "pa-zande": [
        9108,
        9109
    ],
    "pa-dio": [
        9108,
        9109
    ],
    "pazande": [
        9108,
        9109
    ],
    "pa zande": [
        9108,
        9109
    ],
    "pyik mantsi": [
        9112
    ],
    "pyik": [
        9112
    ],
    "pʌt": [
        9113,
        9118,
        9119
    ],
    "petapa zapotec": [
        9124
    ],
    "papabuco": [
        9142,
        9145,
        9160
    ],
    "panika": [
        9149,
        9150
    ],
    "panka": [
        9149,
        9150
    ],
    "pho thai": [
        9188
    ],
    "potai": [
        9188
    ],
    "pu tho": [
        9188
    ],
    "puto": [
        9188
    ]
};
